/**
 * @file Generated by js-routes 2.3.5. Based on Rails 7.0.10 routes of Shoobphoto::Application.
 * @version 898e2b2dfe858946dc010c4a8d0a7c4fa5ff251c4fdd4c4f8decc7a960c82480
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /abandoned_carts_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abandoned_carts_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"abandoned_carts_csv"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /schools/abort_yb_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abort_yb_pages_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"abort_yb_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /about_us(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const about_us_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"about_us"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation/active_apply_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_apply_jobs_admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[2,[7,"/"],[2,[6,"active_apply_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/add_addon/:order_package/:addon(.:format)
 * @param {any} order_package
 * @param {any} addon
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_addon_path = /*#__PURE__*/ __jsr.r({"order_package":{"r":true},"addon":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"add_addon"],[2,[7,"/"],[2,[3,"order_package"],[2,[7,"/"],[2,[3,"addon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/add_addon_pose/:addon_sheet/:index(.:format)
 * @param {any} addon_sheet
 * @param {any} index
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_addon_pose_path = /*#__PURE__*/ __jsr.r({"addon_sheet":{"r":true},"index":{"r":true},"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"add_addon_pose"],[2,[7,"/"],[2,[3,"addon_sheet"],[2,[7,"/"],[2,[3,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/add_appointment/:cart_id/:i(.:format)
 * @param {any} cart_id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_appointment_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"add_appointment"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/add_background/:op/:senior_image/:background(.:format)
 * @param {any} op
 * @param {any} senior_image
 * @param {any} background
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_background_path = /*#__PURE__*/ __jsr.r({"op":{"r":true},"senior_image":{"r":true},"background":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"add_background"],[2,[7,"/"],[2,[3,"op"],[2,[7,"/"],[2,[3,"senior_image"],[2,[7,"/"],[2,[3,"background"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/add_background_elementary/:order_package/:background(.:format)
 * @param {any} order_package
 * @param {any} background
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_background_simple_path = /*#__PURE__*/ __jsr.r({"order_package":{"r":true},"background":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"add_background_elementary"],[2,[7,"/"],[2,[3,"order_package"],[2,[7,"/"],[2,[3,"background"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/add_gift/:cart_id/:i/:gift_id(.:format)
 * @param {any} cart_id
 * @param {any} i
 * @param {any} gift_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_gift_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"i":{"r":true},"gift_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"add_gift"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[3,"i"],[2,[7,"/"],[2,[3,"gift_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /add_item/:cart_id/:item_id(.:format)
 * @param {any} cart_id
 * @param {any} item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_item_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"add_item"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[3,"item_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/add_option/:order_package_id/:option_id(.:format)
 * @param {any} order_package_id
 * @param {any} option_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_option_path = /*#__PURE__*/ __jsr.r({"order_package_id":{"r":true},"option_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"add_option"],[2,[7,"/"],[2,[3,"order_package_id"],[2,[7,"/"],[2,[3,"option_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/cart/:cart_id/add_options/:i/:op_id/:option_id(.:format)
 * @param {any} cart_id
 * @param {any} i
 * @param {any} op_id
 * @param {any} option_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_options_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"i":{"r":true},"op_id":{"r":true},"option_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"add_options"],[2,[7,"/"],[2,[3,"i"],[2,[7,"/"],[2,[3,"op_id"],[2,[7,"/"],[2,[3,"option_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/add_package/:cart/:i/:option(.:format)
 * @param {any} cart
 * @param {any} i
 * @param {any} option
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_package_path = /*#__PURE__*/ __jsr.r({"cart":{"r":true},"i":{"r":true},"option":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"add_package"],[2,[7,"/"],[2,[3,"cart"],[2,[7,"/"],[2,[3,"i"],[2,[7,"/"],[2,[3,"option"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/add_pose/:url/:index/:image_type/:opackage(.:format)
 * @param {any} url
 * @param {any} index
 * @param {any} image_type
 * @param {any} opackage
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_pose_path = /*#__PURE__*/ __jsr.r({"url":{"r":true},"index":{"r":true},"image_type":{"r":true},"opackage":{"r":true},"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"add_pose"],[2,[7,"/"],[2,[3,"url"],[2,[7,"/"],[2,[3,"index"],[2,[7,"/"],[2,[3,"image_type"],[2,[7,"/"],[2,[3,"opackage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/add_student(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_student_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_student"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /add_student_to_cart_from_react(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_student_to_cart_from_react_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"add_student_to_cart_from_react"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /awards/add_student_trait(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_student_trait_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"add_student_trait"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/add_teacher_aids(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_teacher_aids_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_teacher_aids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /template_products/:id/add_to_cart(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_to_cart_template_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"template_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_to_cart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/addons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/addon_sheets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addon_sheet_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"addon_sheets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/addon_sheets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addon_sheets_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"addon_sheets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/addons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addons_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"addons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/:id/adjust_exposure(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adjust_exposure_admin_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"adjust_exposure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/appointments/schedule_appointments/:school_id(.:format)
 * @param {any} school_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_path = /*#__PURE__*/ __jsr.r({"school_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"schedule_appointments"],[2,[7,"/"],[2,[3,"school_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/addons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_addon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/addons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_addons_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"addons"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin/queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_admin_queries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"queries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/components/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_api_component_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/components(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_api_components_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"components"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/html_elements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_api_html_element_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"html_elements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/components/:id/html_elements(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_api_html_elements_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"html_elements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/poses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_api_poses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"poses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/poses_configs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_api_poses_configs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"poses_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/poses_configs/upload_to_s3(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_api_poses_configs_upload_to_s3_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"poses_configs"],[2,[7,"/"],[2,[6,"upload_to_s3"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/students/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_api_student_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_api_tags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/appointments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_appointment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/appointments/day/:school_id(.:format)
 * @param {any} school_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_appointment_day_path = /*#__PURE__*/ __jsr.r({"school_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"day"],[2,[7,"/"],[2,[3,"school_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/appointment_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_appointment_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"appointment_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/appointment_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_appointment_statuses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"appointment_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/appointments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_appointments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"appointments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/awards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_award_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/awards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_awards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"awards"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/backgrounds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_background_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"backgrounds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/background_sets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_background_set_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/background_sets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_background_sets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_sets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/backgrounds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_backgrounds_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"backgrounds"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/banners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_banner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/banners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_banners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaign_filters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_campaign_filter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaign_filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_campaign_filters_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_filters"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/coupons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_coupon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"coupons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/coupons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_coupons_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"coupons"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/navlinks/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_csv_nav_links_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"navlinks"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/packages/:id/csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_csv_packages_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/pages/:id/csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_csv_pages_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_csv_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_job_overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_customer_job_overview_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_job_overview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_registrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_customer_registrations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_registrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_job_overview/cycle_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_cycle_status_customer_job_overview_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_job_overview"],[2,[7,"/"],[2,[6,"cycle_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dashboard_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dashboards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/deliveries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_deliveries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deliveries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/districts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_district_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/districts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_districts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"districts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/download_image_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_download_image_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"download_image_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/packages/:id/email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_csv_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_drafts/templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_drafts_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_drafts"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_drafts/templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_drafts_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_drafts"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/packages/:id/email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_import_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/extras/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_extra_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"extras"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/extra_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_extra_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"extra_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/extra_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_extra_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"extra_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/extras(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_extras_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"extras"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/fall_poses_configs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_fall_poses_configs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"fall_poses_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/foregrounds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_foreground_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"foregrounds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/foregrounds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_foregrounds_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"foregrounds"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_generated_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_generated_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/gifts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_gift_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"gifts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/gifts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_gifts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"gifts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/grad_poses_configs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_grad_poses_configs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"grad_poses_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/navlinks/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_import_nav_links_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"navlinks"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/packages/:id/csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_import_packages_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/pages/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_import_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_import_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/items/all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_items_all_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/items/filter/:subcat(.:format)
 * @param {any} subcat
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_items_filter_path = /*#__PURE__*/ __jsr.r({"subcat":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"filter"],[2,[7,"/"],[2,[3,"subcat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/job_calendar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_job_calendar_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"job_calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/job_reassignment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_job_reassignment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"job_reassignment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/loads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_load_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/loads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_loads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"loads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/low_res_remediation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_low_res_remediation_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"low_res_remediation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/message_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_message_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"message_events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/nav_links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_nav_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nav_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/nav_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_nav_links_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nav_links"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/admin_notes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_notes_admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"admin_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/order_packages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_order_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/otp_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_otp_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"otp_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/packages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/packages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_packages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_options/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_page_option_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_options"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_option_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_page_option_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_option_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_option_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_page_option_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_option_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_page_options_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_options"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_page_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_page_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/pending_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_pending_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pending_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/photographer_notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_photographer_note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"photographer_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/photographer_notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_photographer_notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"photographer_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/poses_configs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_poses_configs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"poses_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/prints/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_print_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prints"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/printess/test(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_printess_test_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"printess"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/prints(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_prints_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prints"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_product_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_product_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/production_tracking_columns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_production_tracking_column_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"production_tracking_columns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/production_tracking_columns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_production_tracking_columns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"production_tracking_columns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/promotion_award_trackings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_promotion_award_tracking_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotion_award_trackings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/qr_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_qr_codes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"qr_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_queries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"queries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/queries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_query_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"queries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rake_tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_rake_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rake_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rake_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_rake_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rake_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/renewal_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_renewal_statuses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"renewal_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/s3_downloads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_s3_downloads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"s3_downloads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_award_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_scheduled_award_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_award_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_scheduled_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_job_logs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_scheduled_job_log_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_job_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_job_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_scheduled_job_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_job_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_scheduled_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_sitting_card_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_scheduled_sitting_card_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_sitting_card_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_school_composite_index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_school_composite_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_school_composite_index"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin_school_districts_for_county(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_school_districts_for_county_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_school_districts_for_county"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:school_id/email_drafts(.:format)
 * @param {any} school_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_school_email_drafts_path = /*#__PURE__*/ __jsr.r({"school_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"school_id"],[2,[7,"/"],[2,[6,"email_drafts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_school_packing_slip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_school_packing_slip_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_school_packing_slip"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin_school_primary_photo_select(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_school_primary_photo_select_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_school_primary_photo_select"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/school_resources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_school_resource_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/school_resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_school_resources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"school_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin_school_sales_call(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_school_sales_call_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_school_sales_call"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin_school_sales_call_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_school_sales_call_export_path = /*#__PURE__*/ __jsr.r({"format":{"d":"csv"}}, [2,[7,"/"],[2,[6,"admin_school_sales_call_export"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin_school_save_primary_changes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_school_save_primary_changes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_school_save_primary_changes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/schools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/senior_blocks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_senior_blocks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"senior_blocks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contracts/:id/admin_sign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sign_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"admin_sign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sms_conversations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sms_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sms_conversations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sms_conversations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sms_conversations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sms_conversations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/special_offers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_special_offer_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"special_offers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/special_offers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_special_offers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"special_offers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/special_package_seasons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_special_package_season_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"special_package_seasons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/special_package_seasons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_special_package_seasons_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"special_package_seasons"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_create_or_edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_student_create_or_edit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_create_or_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_student_images_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_imports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_student_import_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_student_imports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_job_overview/summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_summary_customer_job_overview_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_job_overview"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_job_overview/summary_note(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_summary_note_customer_job_overview_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_job_overview"],[2,[7,"/"],[2,[6,"summary_note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/taxes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_tax_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/taxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_taxes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/template_maintenance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_template_maintenance_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"template_maintenance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/templates/sheets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_templates_sheet_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"sheets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/templates/sheets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_templates_sheets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"sheets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/templating(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_templating_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"templating"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer_job_overview/toggle_main_contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_toggle_main_contact_customer_job_overview_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer_job_overview"],[2,[7,"/"],[2,[6,"toggle_main_contact"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/unsubscribe_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_unsubscribe_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"unsubscribe_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/unsubscribe_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_unsubscribe_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"unsubscribe_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_import_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/where_empty_by_school(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_where_empty_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"where_empty_by_school"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/work_orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_work_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/work_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_work_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"work_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/yearbook_campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_yearbook_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"yearbook_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/yearbook_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_yearbook_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"yearbook_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/yearbook_home_setting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_yearbook_home_setting_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"yearbook_home_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /after_purchase_catalog/:cart_id(.:format)
 * @param {any} cart_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const after_purchase_corder_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"after_purchase_catalog"],[2,[7,"/"],[2,[3,"cart_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/after_purchase(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const after_purchase_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"after_purchase"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /porders/after_purchase(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const after_purchase_porders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"porders"],[2,[7,"/"],[2,[6,"after_purchase"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/items/all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const all_admin_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/all_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const all_jobs_admin_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"all_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/all_schools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const all_schools_admin_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"all_schools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/all_seasons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const all_seasons_admin_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"all_seasons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_login_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_logout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_session_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/djobs/instudio2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_djobs_instudio2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"instudio2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/djobs/instudio_seniors2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_djobs_instudio_seniors2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"instudio_seniors2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/yearbook_home_delivery(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_yearbook_home_delivery_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"yearbook_home_delivery"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/products/add_custom_item(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_products_add_custom_item_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"add_custom_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/favorites_specs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v3_favorites_specs_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"favorites_specs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation/apply_orphan_recovery(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apply_orphan_recovery_admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[2,[7,"/"],[2,[6,"apply_orphan_recovery"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation/apply_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apply_status_admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[2,[7,"/"],[2,[6,"apply_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /appointments/email_reminder_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appointments_email_reminder_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"email_reminder_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/appointments_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appointments_export_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"appointments_export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/assign_queue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assign_queue_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"assign_queue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_failure_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/google_oauth2/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_google_oauth2_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /autos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /autos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const autos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"autos"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/appointments/availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const availability_admin_appointments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation/available_dates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const available_dates_admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[2,[7,"/"],[2,[6,"available_dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/add_info/:award_id/:award_info(.:format)
 * @param {any} id
 * @param {any} award_id
 * @param {any} award_info
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_add_info_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"award_id":{"r":true},"award_info":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_info"],[2,[7,"/"],[2,[3,"award_id"],[2,[7,"/"],[2,[3,"award_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/add_student/:student_id(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_add_student_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"add_student"],[2,[7,"/"],[2,[3,"student_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/clear(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_clear_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_confirm_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/correction_list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_correction_list_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"correction_list"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/corrections(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_corrections_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"corrections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/create_corrections(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_create_corrections_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_corrections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/edit_award_quantity(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_edit_quantity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_award_quantity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/in_progress(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_in_progress_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"in_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /award_infos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_info_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"award_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /award_infos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_infos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"award_infos"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /awards/load_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_load_assets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"load_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/multiple_add_info(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_multiple_add_info_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"multiple_add_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/multiple_clear(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_multiple_clear_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"multiple_clear"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/multiple_student/new/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_multiple_new_student_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"multiple_student"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/review_multiple(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_multiple_review_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/multiple_students/create/:school/:package/:id(.:format)
 * @param {any} school
 * @param {any} package
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_multiple_student_create_path = /*#__PURE__*/ __jsr.r({"school":{"r":true},"package":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"multiple_students"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"school"],[2,[7,"/"],[2,[3,"package"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/mutiple_students(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_multiple_students_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mutiple_students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/multiple_award_update(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_multiple_update_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"multiple_award_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/student/new/:award_id(.:format)
 * @param {any} award_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_new_student_path = /*#__PURE__*/ __jsr.r({"award_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"award_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/print(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_print_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"print"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/print_list(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_print_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"print_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/remove/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_remove_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"remove"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/remove_student/:student_id(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_remove_student_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"remove_student"],[2,[7,"/"],[2,[3,"student_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/review(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_review_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/review_all(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_review_all_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/single_award_update(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_single_update_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"single_award_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/students/create/:school/:package/:award_id(.:format)
 * @param {any} school
 * @param {any} package
 * @param {any} award_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_student_create_path = /*#__PURE__*/ __jsr.r({"school":{"r":true},"package":{"r":true},"award_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"school"],[2,[7,"/"],[2,[3,"package"],[2,[7,"/"],[2,[3,"award_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/students(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_students_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/submit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_submit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/upload_csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_upload_csv_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/waiting(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const award_waiting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"waiting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"awards"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /awards/change_school(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_change_school_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"change_school"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/discard_draft_v2(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_discard_draft_v2_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discard_draft_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/final_submit_v2(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_final_submit_v2_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"final_submit_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/in_progress_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_in_progress_v2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"in_progress_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/lookup_student_ids(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_lookup_student_ids_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lookup_student_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/multiple_awards(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_multiple_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"multiple_awards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/multiple_v2(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_multiple_v2_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"multiple_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/new_student_v2(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_new_student_v2_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_student_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/roster_search_v2(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_roster_search_v2_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"roster_search_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/save_draft_v2(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_save_draft_v2_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_draft_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/single_award(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_single_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"single_award"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/spreadsheet_headers(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_spreadsheet_headers_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"spreadsheet_headers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/submit_v2(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_submit_v2_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/submitted_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awards_submitted_v2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"submitted_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/backgrounds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const background_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"backgrounds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/background_sets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const background_set_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"background_sets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/background_sets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const background_sets_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"background_sets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/background_sets_list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const background_sets_list_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"background_sets_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/backgrounds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backgrounds_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"backgrounds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/backgrounds_for_set(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backgrounds_for_set_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"backgrounds_for_set"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/appointments/breakdown_per_day(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const breakdown_per_day_admin_appointments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"breakdown_per_day"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/bulk_adjust_exposure(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_adjust_exposure_admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bulk_adjust_exposure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/bulk_adjust_exposure_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_adjust_exposure_status_admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bulk_adjust_exposure_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/carts/:id/buy_all(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buy_all_cart_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"buy_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbooks/:id/buy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buy_yearbook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yearbooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"buy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/by_product(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_product_admin_generated_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[6,"by_product"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/bydate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bydate_djobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"bydate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/bysearch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bysearch_djobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"bysearch"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/bysearch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bysearch_dprojects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"bysearch"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /calendars/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"calendars"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/calendar_jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"calendar_jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/calendar_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_jobs_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"calendar_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /calendars(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendars_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"calendars"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webcams/capture(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const capture_webcams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webcams"],[2,[7,"/"],[2,[6,"capture"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/carts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cart_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/carts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"carts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/packages/carts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const carts_admin_packages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[6,"carts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const catalog_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"catalog"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/calendar_jobs/change_log(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_log_calendar_jobs_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"calendar_jobs"],[2,[7,"/"],[2,[6,"change_log"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/:id/changeprimary(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changeprimary_admin_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"changeprimary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/:id/check_for_overriding_attributes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_for_overriding_attributes_djob_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_for_overriding_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/check_missing_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_missing_images_admin_generated_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[6,"check_missing_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cities"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const city_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/class_picture_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const class_picture_pdf_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"class_picture_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/class_pictures(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const class_pictures_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"class_pictures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/order_packages/:id/clear(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_admin_order_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /items/cart/:cart_id/clear(.:format)
 * @param {any} cart_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_catalog_cart_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"clear"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /new_templates/:id/clear_csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_csv_new_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/dprojects/clear_exported_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_exported_entries_dprojects_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"clear_exported_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/order_packages/clear_exported_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_exported_items_order_packages_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[6,"clear_exported_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_packages/:id/clear_shipping(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_shipping_order_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_shipping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /contracts/:id/clear_signature(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_signature_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_signature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_jobs/:id/clone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_admin_scheduled_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:id/clone_with_zip(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clone_with_zip_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clone_with_zip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/close_menu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_menu_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"close_menu"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/columns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const column_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"columns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/columns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const columns_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"columns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/command_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const command_status_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"command_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/components/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/components(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const components_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"components"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_school_composite_approved(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const composite_approved_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_school_composite_approved"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin_school_composite_approved_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const composite_approved_all_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_school_composite_approved_all"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/schools/composite_notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const composite_notes_admin_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"composite_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/composites(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const composites_admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"composites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /porders/confirm/:project_id(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_porders_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"porders"],[2,[7,"/"],[2,[6,"confirm"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_registrations/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmation_customer_registrations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customer_registrations"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contacts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/contact_info(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_info_admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"contact_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/contact_informations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_information_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"contact_informations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/contact_information_models/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_information_model_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"contact_information_models"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/contact_information_models(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_information_models_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"contact_information_models"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/contact_informations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_informations_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"contact_informations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contacts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /contacts/shoob_job(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contacts_shoob_job_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"shoob_job"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contacts/submit_shoob_job(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contacts_submit_shoob_job_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"submit_shoob_job"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contracts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contracts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contracts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contracts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /contracts/generate_contracts_for_schools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contracts_generate_contracts_for_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[6,"generate_contracts_for_schools"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contracts/generate_single_contract(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contracts_generate_single_contract_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[6,"generate_single_contract"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/packages/:id/copy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_admin_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /new_templates/:id/copy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_new_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:id/copy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/:id/copytofall2023(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copytofall2023_admin_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copytofall2023"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /items/:cart_id/orders(.:format)
 * @param {any} cart_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corder_confirm_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /corders/:id/export(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corder_export_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"corders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog_orders/:id/project(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corder_project_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"catalog_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"project"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog_orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corder_show_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"catalog_orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /catalog_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"catalog_orders"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /corders/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corders_import_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"corders"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /catalog_orders/:id/processed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corders_processed_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"catalog_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"processed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /catalog_orders/:id/unprocessed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corders_unprocessed_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"catalog_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unprocessed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/correction_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const correction_status_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"correction_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/corrections_csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corrections_csv_admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"corrections_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/corrections_csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corrections_csv_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"corrections_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/corrections(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corrections_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"corrections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/work_orders/counts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const counts_admin_work_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/coupons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coupon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"coupons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/coupons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coupons_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"coupons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/create_addon/:opackage/:extra(.:format)
 * @param {any} opackage
 * @param {any} extra
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_addon_path = /*#__PURE__*/ __jsr.r({"opackage":{"r":true},"extra":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"create_addon"],[2,[7,"/"],[2,[3,"opackage"],[2,[7,"/"],[2,[3,"extra"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /create_cart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_cart_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"create_cart"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/create_composite_project(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_composite_project_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_composite_project"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/promotion_award_trackings/:id/create_dproject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_dproject_admin_promotion_award_tracking_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promotion_award_trackings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_dproject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/create_notice(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_notice_admin_generated_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[6,"create_notice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/carts/:id/create_payment_intent(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_payment_intent_cart_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_payment_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation/create_pose_record(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_pose_record_admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[2,[7,"/"],[2,[6,"create_pose_record"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/create_project(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_project_admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_project"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/create_shipping_manifest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_shipping_manifest_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"create_shipping_manifest"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/create_student_image(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_student_image_admin_student_images_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[6,"create_student_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/create_tracking_gp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_tracking_gp_admin_generated_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[6,"create_tracking_gp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/create_zip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_zip_admin_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"create_zip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/create_zip_for_metrics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_zip_for_metrics_admin_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"create_zip_for_metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/backgrounds/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csv_admin_backgrounds_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"backgrounds"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboards/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csv_admin_dashboards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csv_admin_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/taxes/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csv_admin_taxes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csv_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csv_dprojects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /new_templates/:id/csv_export_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csv_export_status_new_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"csv_export_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /new_templates/:id/csv_info(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csv_info_new_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"csv_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /school_contact_tbs/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csv_school_contact_tbs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_contact_tbs"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /springappointments/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csv_springappointments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"springappointments"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_email_lists/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csv_yearbook_email_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_email_lists"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customer_registrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customer_registrations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customer_registrations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v2/d_products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const d_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"d_products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/d_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const d_products_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"d_products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/processing/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_admin_processing_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"processing"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/processing/dashboard_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_data_admin_processing_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"processing"],[2,[7,"/"],[2,[6,"dashboard_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbooks/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_yearbooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbooks"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/database_poses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const database_poses_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"database_poses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/dprojects/dates_available_for_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dates_available_for_export_dprojects_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"dates_available_for_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /contracts/:id/decline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decline_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/delete_addon/:opackage/:extra(.:format)
 * @param {any} opackage
 * @param {any} extra
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_addon_path = /*#__PURE__*/ __jsr.r({"opackage":{"r":true},"extra":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"delete_addon"],[2,[7,"/"],[2,[3,"opackage"],[2,[7,"/"],[2,[3,"extra"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/delete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /delete_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"delete_orders"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/delete_schedule(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_schedule_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"delete_schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/items/:id/delete_search_term(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_search_term_admin_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_search_term"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /items/:id/delete_search_term(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const delete_search_term_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_search_term"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/deploy_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deploy_info_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"deploy_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/deploy_to_instances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deploy_to_instances_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"deploy_to_instances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/districts/:id/destroy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_admin_district_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_api_user_session_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/digital_id_cards(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const digital_id_cards_admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"digital_id_cards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_drafts/templates/disconnect_google(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disconnect_google_admin_email_drafts_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_drafts"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"disconnect_google"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /checkouts/display_student(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const display_student_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[6,"display_student"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/districts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const district_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /school_notes/district(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const district_school_notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_notes"],[2,[7,"/"],[2,[6,"district"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/districts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const districts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"districts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djob_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/djob_packing_slip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djob_packing_slip_admin_generated_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[6,"djob_packing_slip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /djob_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djob_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"djob_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djob_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djob_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djob_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /djobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /djobs/adjust_brightness(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_adjust_brightness_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"adjust_brightness"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/apply_curve_preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_apply_curve_preview_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"apply_curve_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/brighten_all_rig(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_brighten_all_rig_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"brighten_all_rig"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/brighten_all_rig_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_brighten_all_rig_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"brighten_all_rig_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/curve_batch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_curve_batch_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"curve_batch"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/curve_batch_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_curve_batch_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"curve_batch_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs_export_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_export_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs_export_csv"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /djobs/face_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_face_details_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"face_details"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/facedetailscsv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_facedetailscsv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"facedetailscsv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/filter_djobs_by_photographer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_filter_djobs_by_photographer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"filter_djobs_by_photographer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_jobs/:id/djobs_for_school(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_for_school_admin_scheduled_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"djobs_for_school"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/graduation_import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_graduation_import_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"graduation_import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/graduation_import_presign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_graduation_import_presign_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"graduation_import_presign"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/graduation_import_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_graduation_import_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"graduation_import_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/graduation_unmatched_zip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_graduation_unmatched_zip_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"graduation_unmatched_zip"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/jobs_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_jobs_report_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"jobs_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/load_s3_curve(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_load_s3_curve_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"load_s3_curve"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/makecsv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_makecsv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"makecsv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/milage_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_milage_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"milage_form"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/nickcsv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_nickcsv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"nickcsv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/orders_from_job(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_orders_from_job_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"orders_from_job"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/photo_enlarge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_photo_enlarge_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"photo_enlarge"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/photographer_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_photographer_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"photographer_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/photography_job_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_photography_job_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"photography_job_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/photos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_photos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"photos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/photos_filtered(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_photos_filtered_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"photos_filtered"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/print_grad_pricelist(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_print_grad_pricelist_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"print_grad_pricelist"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/print_slip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_print_slip_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"print_slip"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/reconcile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_reconcile_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"reconcile"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/recrop_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_recrop_all_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"recrop_all"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/recrop_all_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_recrop_all_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"recrop_all_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/recrop_selected(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_recrop_selected_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"recrop_selected"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/recrop_selected_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_recrop_selected_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"recrop_selected_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/repush_skylab_fails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_repush_skylab_fails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"repush_skylab_fails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/s3_counts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_s3_counts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"s3_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/scan_faces(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_scan_faces_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"scan_faces"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/scan_faces_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_scan_faces_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"scan_faces_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/search_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_search_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"search_students"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/set_best_pose(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_set_best_pose_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"set_best_pose"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/sports_import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_sports_import_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"sports_import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/sports_import_presign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_sports_import_presign_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"sports_import_presign"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/sports_import_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_sports_import_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"sports_import_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/view_recropped(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobs_view_recropped_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"view_recropped"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobsconfirms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobsconfirms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobsconfirms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /djobshomebase(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobshomebase_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobshomebase"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /djobsphotography(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobsphotography_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobsphotography"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /djobsproduction(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobsproduction_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobsproduction"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /djobsproduction_tracking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const djobsproduction_tracking_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobsproduction_tracking"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/students/dob_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dob_count_students_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"dob_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/download_all_grade_yb_pages(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_all_grade_yb_pages_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_all_grade_yb_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/download_all_pdfs(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_all_pdfs_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_all_pdfs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/download_all_yb_pages(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_all_yb_pages_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_all_yb_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /items/download_calendar_template(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_calendar_template_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"download_calendar_template"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /download/cart/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_cart_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /download/check_image_availability(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_check_image_availability_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"check_image_availability"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /download/create_cart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_create_cart_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"create_cart"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /download/create_download_work_order(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_create_download_work_order_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"create_download_work_order"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/awards/:id/download_csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_csv_admin_award_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/download_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_csv_admin_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"download_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /download/customer_zip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_customer_zip_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"customer_zip"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /download/download_all_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_download_all_images_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"download_all_images"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export/download_export_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_export_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"download_export_students"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /items/download_image(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_image_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"download_image"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/download_images(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_images_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laptop_files/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_laptop_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laptop_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /items/download_pdf(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_pdf_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"download_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/download_proofs(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_proofs_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_proofs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /order/download_image/:order_package(.:format)
 * @param {any} order_package
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_push_image_path = /*#__PURE__*/ __jsr.r({"order_package":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order"],[2,[7,"/"],[2,[6,"download_image"],[2,[7,"/"],[2,[3,"order_package"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /school_files/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_school_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"school_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /school_files/:id/download_school_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_school_file_school_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"school_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_school_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/download_yb_page(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_yb_page_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_yb_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/download_yearbook_images_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_yearbook_images_csv_admin_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"download_yearbook_images_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/download_zip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_zip_admin_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"download_zip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/qr_codes/download_zip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_zip_admin_qr_codes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"qr_codes"],[2,[7,"/"],[2,[6,"download_zip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /download/zip_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_zip_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"zip_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/attachment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_attachment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attachment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:dproject_id/dattachments/:id(.:format)
 * @param {any} dproject_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_dattachment_path = /*#__PURE__*/ __jsr.r({"dproject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"dproject_id"],[2,[7,"/"],[2,[6,"dattachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:dproject_id/dattachments(.:format)
 * @param {any} dproject_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_dattachments_path = /*#__PURE__*/ __jsr.r({"dproject_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"dproject_id"],[2,[7,"/"],[2,[6,"dattachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/designmergecsv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_designmergecsv_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"designmergecsv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:dproject_id/dprojecttests/:id(.:format)
 * @param {any} dproject_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_dprojecttest_path = /*#__PURE__*/ __jsr.r({"dproject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"dproject_id"],[2,[7,"/"],[2,[6,"dprojecttests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:dproject_id/dprojecttests(.:format)
 * @param {any} dproject_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_dprojecttests_path = /*#__PURE__*/ __jsr.r({"dproject_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"dproject_id"],[2,[7,"/"],[2,[6,"dprojecttests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_duplicate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/fetch_shipping_rates(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_fetch_shipping_rates_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"fetch_shipping_rates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:dproject_id/invoices/:id(.:format)
 * @param {any} dproject_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_invoice_path = /*#__PURE__*/ __jsr.r({"dproject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"dproject_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:dproject_id/invoices(.:format)
 * @param {any} dproject_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_invoices_path = /*#__PURE__*/ __jsr.r({"dproject_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"dproject_id"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/packingslip(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_packingslip_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"packingslip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/print(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_print_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"print"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/priority(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_priority_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"priority"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/purchase_shipping_label(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_purchase_shipping_label_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"purchase_shipping_label"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/school_barcode(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_school_barcode_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"school_barcode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/ship(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_ship_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ship"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/shipping(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_shipping_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"shipping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/shipping_label(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_shipping_label_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"shipping_label"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/spirit_week_poster_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_spirit_week_poster_pdf_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"spirit_week_poster_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/template_jpg(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_template_jpg_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"template_jpg"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/template_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_template_pdf_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"template_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/validate_shipping_address(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_validate_shipping_address_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"validate_shipping_address"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/void_shipping_label(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dproject_void_shipping_label_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"void_shipping_label"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/dprojects(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"dprojects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/booklet_calendar_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_booklet_calendar_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"booklet_calendar_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/calendars_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_calendars_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"calendars_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/daily_status_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_daily_status_report_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"daily_status_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/halloween_grams_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_halloween_grams_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"halloween_grams_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/holiday_cards_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_holiday_cards_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"holiday_cards_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/kindness_week_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_kindness_week_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"kindness_week_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/red_ribbon_week_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_red_ribbon_week_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"red_ribbon_week_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/retirement_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_retirement_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"retirement_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/shipreport(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_shipreport_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"shipreport"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/teacher_appreciation_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_teacher_appreciation_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"teacher_appreciation_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/thanksgiving_grams_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_thanksgiving_grams_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"thanksgiving_grams_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/valentine_grams_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_valentine_grams_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"valentine_grams_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/winter_grams_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dprojects_winter_grams_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"winter_grams_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dschools/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dschool_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dschools"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dschools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dschools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dschools"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_admin_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/addons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_addon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/appointments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_appointment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/awards/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_award_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/backgrounds/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_background_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"backgrounds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/background_sets/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_background_set_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_sets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/banners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_banner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaign_filters/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_campaign_filter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_filters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/coupons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_coupon_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"coupons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboards/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/districts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_district_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_drafts/templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_email_drafts_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_drafts"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/extras/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_extra_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"extras"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/extra_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_extra_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"extra_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/foregrounds/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_foreground_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"foregrounds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/gifts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_gift_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"gifts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/nav_links/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_nav_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nav_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/order_packages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_order_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/packages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_options/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_page_option_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_options"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_option_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_page_option_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_option_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_page_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/photographer_notes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_photographer_note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"photographer_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/prints/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_print_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prints"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_product_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/production_tracking_columns/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_production_tracking_column_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"production_tracking_columns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/queries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_query_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"queries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rake_tasks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_rake_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rake_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_jobs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_scheduled_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_job_logs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_scheduled_job_log_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_job_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/school_resources/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_school_resource_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/special_offers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_special_offer_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"special_offers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/special_package_seasons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_special_package_season_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"special_package_seasons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_imports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_student_import_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/taxes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_tax_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/templates/sheets/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_templates_sheet_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"sheets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/work_orders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_work_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /autos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_auto_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /award_infos/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_award_info_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"award_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/awards/:id/edit_award_info(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_award_info_admin_award_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_award_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /calendars/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_calendar_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"calendars"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/carts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_cart_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cities/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_city_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /contacts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_contact_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/contact_informations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_contact_information_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"contact_informations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/contact_information_models/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_contact_information_model_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"contact_information_models"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /contracts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/d_products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_d_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"d_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/edit_data_requested(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_data_requested_djobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"edit_data_requested"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/edit_data_requested_id(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_data_requested_id_djobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"edit_data_requested_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/districts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_district_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_djob_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /djob_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_djob_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"djob_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dproject_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:dproject_id/dattachments/:id/edit(.:format)
 * @param {any} dproject_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dproject_dattachment_path = /*#__PURE__*/ __jsr.r({"dproject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"dproject_id"],[2,[7,"/"],[2,[6,"dattachments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:dproject_id/dprojecttests/:id/edit(.:format)
 * @param {any} dproject_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dproject_dprojecttest_path = /*#__PURE__*/ __jsr.r({"dproject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"dproject_id"],[2,[7,"/"],[2,[6,"dprojecttests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:dproject_id/invoices/:id/edit(.:format)
 * @param {any} dproject_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dproject_invoice_path = /*#__PURE__*/ __jsr.r({"dproject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"dproject_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dschools/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dschool_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dschools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export_lists/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_export_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export_list_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_export_list_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export_list_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /face_matches/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_face_match_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"face_matches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/failed_access_code_attempts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_failed_access_code_attempt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"failed_access_code_attempts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fields/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_field_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /guides/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_guide_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /guide_pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_guide_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"guide_pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /guide_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_guide_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"guide_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /id_cards/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_id_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"id_cards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/edit_images_processed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_images_processed_djobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"edit_images_processed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /imgreviews/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_imgreview_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"imgreviews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /laptop_files/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_laptop_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laptop_files"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /order_packages/edit_multiple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_multiple_order_packages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[6,"edit_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /new_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_new_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/notes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/edit_notices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_notices_djobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"edit_notices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /order_packages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_order_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/edit_password(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_password_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /photographers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_photographer_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"photographers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /porders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_porder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"porders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/poses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_pose_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"poses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_project_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/renewal_statuses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_renewal_status_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"renewal_statuses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sales_charts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_sales_chart_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sales_charts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/school_contact_logs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_school_contact_log_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"school_contact_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /school_contact_tbs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_school_contact_tb_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"school_contact_tbs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /school_notes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_school_note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"school_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /school_resources/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_school_resource_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/school_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_school_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"school_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /searches/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_search_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"searches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/senior_images/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_senior_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"senior_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/edit_spec_requested(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_spec_requested_djobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"edit_spec_requested"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /springappointments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_springappointment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"springappointments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/students/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_student_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student_images/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /successful_access_code_attempts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_successful_access_code_attempt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"successful_access_code_attempts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/fields/:id/edit(.:format)
 * @param {any} template_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_template_field_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/template_pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_template_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"template_pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/pdfs/:id/edit(.:format)
 * @param {any} template_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_template_pdf_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"pdfs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/pdfs/:pdf_id/types/:id/edit(.:format)
 * @param {any} template_id
 * @param {any} pdf_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_template_pdf_type_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"pdf_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"pdfs"],[2,[7,"/"],[2,[3,"pdf_id"],[2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/unprocessed_poses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_unprocessed_pose_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"unprocessed_poses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /unsubscribe_lists/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_unsubscribe_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webcams/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_webcam_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"webcams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbooks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_yearbook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yearbooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_yearbook_admin_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/yearbook_contract_details/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_yearbook_contract_detail_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"yearbook_contract_details"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_email_lists/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_yearbook_email_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yearbook_email_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/yearbook_previews/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_yearbook_preview_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"yearbook_previews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_requests/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_yearbook_request_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yearbook_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_submissions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_yearbook_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yearbook_submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/edit_yearbooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_yearbooks_djobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"edit_yearbooks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/educators/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const educator_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"educators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/educators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const educators_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"educators"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/email_sec1_composite_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_sec1_composite_info_admin_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"email_sec1_composite_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/email_tracking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_tracking_admin_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"email_tracking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emailers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emailer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emailers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/enqueue_schools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enqueue_schools_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"enqueue_schools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/enqueue_unprocessed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enqueue_unprocessed_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"enqueue_unprocessed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export/enroll/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enroll_export_list_items_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"enroll"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/job_reassignment/execute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_admin_job_reassignment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"job_reassignment"],[2,[7,"/"],[2,[6,"execute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/qr_codes/export2poses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export2poses_admin_qr_codes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"qr_codes"],[2,[7,"/"],[2,[6,"export2poses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export/add_student/:student_id(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_add_student_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"add_student"],[2,[7,"/"],[2,[3,"student_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/backgrounds/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_admin_backgrounds_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"backgrounds"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_admin_invoices_path = /*#__PURE__*/ __jsr.r({"format":{"d":"csv"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/items/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_admin_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/export(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/qr_codes/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_admin_qr_codes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"qr_codes"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_admin_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export/awards/:uniq_id(.:format)
 * @param {any} uniq_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_awards_path = /*#__PURE__*/ __jsr.r({"uniq_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"uniq_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export/batch/:school_id(.:format)
 * @param {any} school_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_batch_path = /*#__PURE__*/ __jsr.r({"school_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"batch"],[2,[7,"/"],[2,[3,"school_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/packages/export_carts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_carts_admin_packages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[6,"export_carts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export/clean_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_clean_up_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"clean_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export/clear(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_clear_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"clear"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export/students/create/:school/:package(.:format)
 * @param {any} school
 * @param {any} package
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_create_path = /*#__PURE__*/ __jsr.r({"school":{"r":true},"package":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"create"],[2,[7,"/"],[2,[3,"school"],[2,[7,"/"],[2,[3,"package"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/:id/export_csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_csv_admin_generated_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_job_logs/:id/export_csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_csv_admin_scheduled_job_log_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_job_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_sitting_card_logs/:id/export_csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_csv_admin_scheduled_sitting_card_log_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_sitting_card_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/work_orders/export_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_csv_admin_work_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"export_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export/custom_input/:id/type/:type_id/form/:package(.:format)
 * @param {any} id
 * @param {any} type_id
 * @param {any} package
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_custom_input_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type_id":{"r":true},"package":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"custom_input"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"type"],[2,[7,"/"],[2,[3,"type_id"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[3,"package"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /export/delete/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_delete_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export/deselect_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_deselect_all_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"deselect_all"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export/download/:student_id/:image_id(.:format)
 * @param {any} student_id
 * @param {any} image_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_download_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"image_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[3,"image_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/order_packages/export_downloadable_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_downloadable_images_order_packages_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[6,"export_downloadable_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /export/students/:id/type/:type_id/form/:package(.:format)
 * @param {any} id
 * @param {any} type_id
 * @param {any} package
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_form_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type_id":{"r":true},"package":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"type"],[2,[7,"/"],[2,[3,"type_id"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[3,"package"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /export/students/:id/type/:type_id/form/:package/template/:template_id(.:format)
 * @param {any} id
 * @param {any} type_id
 * @param {any} package
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_form_two_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"type_id":{"r":true},"package":{"r":true},"template_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"type"],[2,[7,"/"],[2,[3,"type_id"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[3,"package"],[2,[7,"/"],[2,[6,"template"],[2,[7,"/"],[2,[3,"template_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /export_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export_list_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_list_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export_list_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export_list_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_list_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export_list_items"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /export_list_items/free_teacher_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_list_items_free_teacher_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export_list_items"],[2,[7,"/"],[2,[6,"free_teacher_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export_list_items/problemids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_list_items_problemids_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export_list_items"],[2,[7,"/"],[2,[6,"problemids"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export_list_items/problemidscsv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_list_items_problemidscsv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export_list_items"],[2,[7,"/"],[2,[6,"problemidscsv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export_list_items/retake_pdf(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_list_items_retake_pdf_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export_list_items"],[2,[7,"/"],[2,[6,"retake_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export_list_items/statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_list_items_statistics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export_list_items"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export/remove/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_list_remove_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"remove"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export/zip/:school/:package(.:format)
 * @param {any} school
 * @param {any} package
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_list_zip_path = /*#__PURE__*/ __jsr.r({"school":{"r":true},"package":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[3,"school"],[2,[7,"/"],[2,[3,"package"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /export_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export_lists"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /export/load_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_load_assets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"load_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export/load_school_user_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_load_school_user_assets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"load_school_user_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export/students/new/:school/:package(.:format)
 * @param {any} school
 * @param {any} package
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_new_path = /*#__PURE__*/ __jsr.r({"school":{"r":true},"package":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"school"],[2,[7,"/"],[2,[3,"package"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_award_logs/:id/export_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_pdf_admin_scheduled_award_log_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_award_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /export/problemids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_problemids_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"problemids"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export/remove_student/:student_id(.:format)
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_remove_student_path = /*#__PURE__*/ __jsr.r({"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"remove_student"],[2,[7,"/"],[2,[3,"student_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export/schools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"schools"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export/students/search/:school(.:format)
 * @param {any} school
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_search_path = /*#__PURE__*/ __jsr.r({"school":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[3,"school"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /export/search/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_searches_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export/select_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_select_all_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"select_all"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/order_packages/export_shipped(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_shipped_order_packages_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[6,"export_shipped"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /export/show/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_show_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/export_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_status_admin_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"export_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export/students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export_list_items/export_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_students_export_list_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export_list_items"],[2,[7,"/"],[2,[6,"export_students"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export/students/sittings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_students_sittings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"sittings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export/students/:id/:school/type(.:format)
 * @param {any} id
 * @param {any} school
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_types_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"school":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"school"],[2,[7,"/"],[2,[6,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation/export_unresolved(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_unresolved_admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[2,[7,"/"],[2,[6,"export_unresolved"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export/update/:id/:package(.:format)
 * @param {any} id
 * @param {any} package
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_update_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"package":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"package"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /export/school_user/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_user_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"school_user"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export/waiting/:id/:package(.:format)
 * @param {any} id
 * @param {any} package
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_waiting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"package":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"waiting"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"package"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /export/waiting_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_waiting_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export"],[2,[7,"/"],[2,[6,"waiting_students"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/qr_codes/exportall2poses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportall2poses_admin_qr_codes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"qr_codes"],[2,[7,"/"],[2,[6,"exportall2poses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/qr_codes/exportstickers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportstickers_admin_qr_codes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"qr_codes"],[2,[7,"/"],[2,[6,"exportstickers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/extras/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const extra_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"extras"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/extras(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const extras_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"extras"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /face_matches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const face_match_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"face_matches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/students/face_match(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const face_match_students_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"face_match"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /face_matches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const face_matches_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"face_matches"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /face_matches/face_matches/load_display_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const face_matches_face_matches_load_display_images_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"face_matches"],[2,[7,"/"],[2,[6,"face_matches"],[2,[7,"/"],[2,[6,"load_display_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /face_matches/face_matches/move_pose(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const face_matches_face_matches_move_pose_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"face_matches"],[2,[7,"/"],[2,[6,"face_matches"],[2,[7,"/"],[2,[6,"move_pose"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /face_matching(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const face_matching_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"face_matching"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v2/failed_access_code_attempts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const failed_access_code_attempt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"failed_access_code_attempts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/failed_access_code_attempts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const failed_access_code_attempts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"failed_access_code_attempts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fields/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const field_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fields_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/items/filter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filter_admin_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"filter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/deliveries/find_project(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_project_admin_deliveries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deliveries"],[2,[7,"/"],[2,[6,"find_project"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/find_student_image(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_student_image_admin_student_images_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[6,"find_student_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/students/find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_students_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fonts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const font_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fonts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fonts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fonts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fonts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /coupons/for_cart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const for_cart_coupons_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"coupons"],[2,[7,"/"],[2,[6,"for_cart"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/foregrounds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const foreground_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"foregrounds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/foregrounds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const foregrounds_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"foregrounds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/generate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_admin_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/s3_downloads/generate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_admin_s3_downloads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"s3_downloads"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/generate_cards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_cards_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"generate_cards"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /students/generate_cart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_cart_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"generate_cart"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/generate_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_csv_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"generate_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /new_templates/:id/generate_csv_pdfs(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_csv_pdfs_new_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_csv_pdfs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /new_templates/:id/generate_id_card(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_id_card_new_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_id_card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:id/generate_id_card(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_id_card_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_id_card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /new_templates/:id/generate_jpg(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_jpg_new_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_jpg"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/generate_jpg(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_jpg_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"generate_jpg"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/generate_missing_gifs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_missing_gifs_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"generate_missing_gifs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/generate_missing_gifs_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_missing_gifs_status_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"generate_missing_gifs_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /contracts/:id/generate_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_pdf_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /items/cart/:cart_id/item/:item_id/generate_proof(.:format)
 * @param {any} cart_id
 * @param {any} item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_proof_pdf_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"item"],[2,[7,"/"],[2,[3,"item_id"],[2,[7,"/"],[2,[6,"generate_proof"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/:id/generate_sitting_cards(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_sitting_cards_djob_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_sitting_cards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/generate_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_students_admin_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"generate_students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/generate_yearbook_preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_yearbook_preview_admin_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"generate_yearbook_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/students/generate_yearbook_preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_yearbook_preview_students_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"generate_yearbook_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/generation_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generation_status_admin_generated_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[6,"generation_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_imports/get_headers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_headers_admin_student_imports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_imports"],[2,[7,"/"],[2,[6,"get_headers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /award_infos/:id/get_headers(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_headers_award_info_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"award_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_headers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/get_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_logs_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"get_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/get_process_all_flag(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_process_all_flag_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"get_process_all_flag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/get_schedule(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_schedule_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"get_schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /items/cart/:cart_id/item/:item_id/draft(.:format)
 * @param {any} cart_id
 * @param {any} item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const get_template_draft_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"item"],[2,[7,"/"],[2,[3,"item_id"],[2,[7,"/"],[2,[6,"draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/gift_packages/:cart_id/:i(.:format)
 * @param {any} cart_id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gift_packages_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"gift_packages"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /guarantee(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guarantee_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"guarantee"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /guides/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guide_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /guide_pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guide_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"guide_pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /guide_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guide_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"guide_pages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /guide_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guide_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"guide_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /guide_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guide_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"guide_templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /guides(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guides_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"guides"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/students/has_previous_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const has_previous_orders_students_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"has_previous_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /headshot/capture(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const headshot_capture_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"headshot"],[2,[7,"/"],[2,[6,"capture"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /help(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/packages/:id/hide(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hide_admin_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"hide"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_jobs/:id/history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const history_admin_scheduled_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/calendar_jobs/:id/history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const history_calendar_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"calendar_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /checkouts/home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkouts"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /homebase(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const homebase_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"homebase"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /homebase/milage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const homebase_milage_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"homebase"],[2,[7,"/"],[2,[6,"milage"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/html_elements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const html_element_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"html_elements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/html_elements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const html_elements_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"html_elements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /id_cards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const id_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"id_cards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /id_cards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const id_cards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"id_cards"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /id_cards/find_me(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const id_cards_find_me_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"id_cards"],[2,[7,"/"],[2,[6,"find_me"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/id_cards(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const id_cards_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"id_cards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/image_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const image_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"image_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/image_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const image_types_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"image_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /imgreviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const imgreview_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"imgreviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /imgreviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const imgreviews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"imgreviews"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /imgreviews/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const imgreviews_download_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"imgreviews"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /imgreviews/missing_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const imgreviews_missing_images_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"imgreviews"],[2,[7,"/"],[2,[6,"missing_images"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /imgreviews/save_imgs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const imgreviews_save_imgs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"imgreviews"],[2,[7,"/"],[2,[6,"save_imgs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboards/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_admin_dashboards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_admin_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/taxes/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_admin_taxes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /calendars/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_calendars_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"calendars"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_imports/:id/import_csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_csv_admin_student_import_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /new_templates/:id/import_csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_csv_new_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_djobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_dprojects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emailers/csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_emailer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emailers"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export_list_items/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_export_list_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export_list_items"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/import_response_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_response_count_admin_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"import_response_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /school_contact_tbs/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_school_contact_tbs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_contact_tbs"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /springappointments/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_springappointments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"springappointments"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_email_lists/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_yearbook_email_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_email_lists"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_files/import_zips(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_zips_school_files_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_files"],[2,[7,"/"],[2,[6,"import_zips"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export_list_items/importemailphone/:school_id(.:format)
 * @param {any} school_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importemailphone_path = /*#__PURE__*/ __jsr.r({"school_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"export_list_items"],[2,[7,"/"],[2,[6,"importemailphone"],[2,[7,"/"],[2,[3,"school_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/importstaff(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importstaff_admin_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"importstaff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /school_files/incoming_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const incoming_files_school_files_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_files"],[2,[7,"/"],[2,[6,"incoming_files"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/components/:id/html_elements/insert(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insert_admin_api_html_elements_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"html_elements"],[2,[7,"/"],[2,[6,"insert"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /invoices/send_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoices_send_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/itemized_orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const itemized_orders_admin_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"itemized_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /items/add/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_add_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"add"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /items/all/:cart(.:format)
 * @param {any} cart
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_all_path = /*#__PURE__*/ __jsr.r({"cart":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"all"],[2,[7,"/"],[2,[3,"cart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /items/cart/:cart_id(.:format)
 * @param {any} cart_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_cart_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /items/cart/JUPJRGNK(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_cart_JUPJRGNK_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[6,"JUPJRGNK"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /items/cart/:cart_id/cat/:cat(.:format)
 * @param {any} cart_id
 * @param {any} cat
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_cart_outside_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"cat":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"cat"],[2,[7,"/"],[2,[3,"cat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /items/custom_item_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_custom_item_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"custom_item_form"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /items/filter/:cart/:subcat(.:format)
 * @param {any} cart
 * @param {any} subcat
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_filter_path = /*#__PURE__*/ __jsr.r({"cart":{"r":true},"subcat":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"filter"],[2,[7,"/"],[2,[3,"cart"],[2,[7,"/"],[2,[3,"subcat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /items/next/:id/:cart(.:format)
 * @param {any} id
 * @param {any} cart
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_next_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cart":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"next"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"cart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /items/outside/:cat(.:format)
 * @param {any} cat
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_outside_path = /*#__PURE__*/ __jsr.r({"cat":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"outside"],[2,[7,"/"],[2,[3,"cat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /items/preview/:id/:cart(.:format)
 * @param {any} id
 * @param {any} cart
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_preview_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cart":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"preview"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"cart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /items/previous/:id/:cart(.:format)
 * @param {any} id
 * @param {any} cart
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_previous_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"cart":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"previous"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"cart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /items/cart/:cart_id/quantity(.:format)
 * @param {any} cart_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_quantity_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"quantity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /items/remove/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_remove_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"remove"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /items/search/:cart(.:format)
 * @param {any} cart
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const items_search_path = /*#__PURE__*/ __jsr.r({"cart":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[3,"cart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/jobs(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jobs_admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /laptop_files/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laptop_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"laptop_files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /laptop_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const laptop_files_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"laptop_files"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /school_notes/last(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const last_school_notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_notes"],[2,[7,"/"],[2,[6,"last"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/layout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const layout_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"layout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/awards/list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const list_admin_awards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/look_purchase_counts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const look_purchase_counts_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"look_purchase_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/looks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const looks_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"looks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/generated_products/:id/lookup(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookup_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /contracts/:id/mail_contract(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mail_contract_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mail_contract"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/awards/:id/make_projects(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_projects_admin_award_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"make_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/makecsv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const makecsv_admin_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"makecsv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/deliveries/:id/mark_as_delivered(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_delivered_admin_delivery_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"deliveries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_delivered"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/dprojects/:id/mark_as_delivered(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_delivered_dproject_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_delivered"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/dprojects/mark_as_shipped(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_shipped_dprojects_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"mark_as_shipped"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/orders/mark_as_shipped(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_shipped_orders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"mark_as_shipped"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id/mark_as_work_order(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_work_order_admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_work_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/low_res_remediation/:id/mark_resolved(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_resolved_admin_low_res_remediation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"low_res_remediation"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_resolved"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notes/mass_deleter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mass_deleter_notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[6,"mass_deleter"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/educators/match_teacher_to_student(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const match_teacher_to_student_educators_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"educators"],[2,[7,"/"],[2,[6,"match_teacher_to_student"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/me(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const me_users_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"me"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/menu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const menu_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"menu"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/students/merge_teachers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const merge_teachers_students_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"merge_teachers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messages_admin_generated_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboards/missing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missing_admin_dashboards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"missing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/appointments/missing_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missing_images_admin_appointments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"missing_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_jobs/monitor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitor_admin_scheduled_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_jobs"],[2,[7,"/"],[2,[6,"monitor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_jobs/monitor_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monitor_data_admin_scheduled_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_jobs"],[2,[7,"/"],[2,[6,"monitor_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/calendar_jobs/:id/move(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_calendar_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"calendar_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/move_pose(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_pose_admin_student_images_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[6,"move_pose"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/:id/move_poses(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_poses_admin_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move_poses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/multi_packing_slip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_packing_slip_admin_generated_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[6,"multi_packing_slip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /my_cards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_cards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"my_cards"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /myclass(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const myclass_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"myclass"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/addons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_addon_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/appointments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_appointment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/awards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_award_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/backgrounds/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_background_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"backgrounds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/background_sets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_background_set_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"background_sets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/banners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_banner_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_campaign_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaign_filters/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_campaign_filter_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_filters"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_category_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/coupons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_coupon_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"coupons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/districts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_district_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_drafts/templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_email_drafts_template_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_drafts"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/extras/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_extra_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"extras"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/extra_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_extra_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"extra_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/foregrounds/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_foreground_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"foregrounds"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/gifts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_gift_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"gifts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_invoice_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_item_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/nav_links/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_nav_link_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"nav_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_order_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/packages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_package_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_options/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_page_option_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_options"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_option_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_page_option_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_option_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/page_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_page_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"page_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/photographer_notes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_photographer_note_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"photographer_notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/prints/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_print_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prints"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_product_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/product_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_product_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"product_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/production_tracking_columns/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_production_tracking_column_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"production_tracking_columns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/queries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_query_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"queries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rake_tasks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_rake_task_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rake_tasks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_jobs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_scheduled_job_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_jobs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_job_logs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_scheduled_job_log_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_job_logs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_school_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:school_id/email_drafts/new(.:format)
 * @param {any} school_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_school_email_draft_path = /*#__PURE__*/ __jsr.r({"school_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"school_id"],[2,[7,"/"],[2,[6,"email_drafts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/school_resources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_school_resource_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/special_offers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_special_offer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"special_offers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/special_package_seasons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_special_package_season_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"special_package_seasons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_imports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_student_import_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/taxes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_tax_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/templates/sheets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_templates_sheet_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"sheets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/unsubscribe_lists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_unsubscribe_list_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"unsubscribe_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/work_orders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_work_order_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_user_session_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /autos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_auto_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"autos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /awards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_award_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /award_infos/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_award_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"award_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /awards/new_v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_award_v2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[6,"new_v2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /calendars/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_calendar_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"calendars"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/carts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_cart_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_category_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cities/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_city_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contacts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_contact_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/contact_informations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_contact_information_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"contact_informations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/contact_information_models/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_contact_information_model_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"contact_information_models"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /contracts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_contract_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /items/:cart_id/orders/new(.:format)
 * @param {any} cart_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_corder_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/d_products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_d_product_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"d_products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/districts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_district_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_djob_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djob_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_djob_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djob_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dproject_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:dproject_id/dattachments/new(.:format)
 * @param {any} dproject_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dproject_dattachment_path = /*#__PURE__*/ __jsr.r({"dproject_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"dproject_id"],[2,[7,"/"],[2,[6,"dattachments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:dproject_id/dprojecttests/new(.:format)
 * @param {any} dproject_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dproject_dprojecttest_path = /*#__PURE__*/ __jsr.r({"dproject_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"dproject_id"],[2,[7,"/"],[2,[6,"dprojecttests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:dproject_id/invoices/new(.:format)
 * @param {any} dproject_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dproject_invoice_path = /*#__PURE__*/ __jsr.r({"dproject_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"dproject_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dschools/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dschool_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dschools"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export_lists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_export_list_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /export_list_items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_export_list_item_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export_list_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /face_matches/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_face_match_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"face_matches"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/failed_access_code_attempts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_failed_access_code_attempt_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"failed_access_code_attempts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fields/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_field_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /guides/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_guide_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /guide_pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_guide_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"guide_pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /guide_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_guide_template_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"guide_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /id_cards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_id_card_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"id_cards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /imgreviews/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_imgreview_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"imgreviews"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invoices/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_invoice_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_item_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /laptop_files/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_laptop_file_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"laptop_files"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /new_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_new_template_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"new_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/notes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_note_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/cart/:cart_id/orders/new(.:format)
 * @param {any} cart_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_order_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_packages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_order_package_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /photographers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_photographer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"photographers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /porders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_porder_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"porders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /porders/new/:project_id(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_porders_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"porders"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[3,"project_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/poses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_pose_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"poses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_product_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_project_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/renewal_statuses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_renewal_status_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"renewal_statuses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sales_charts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_sales_chart_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sales_charts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /schools/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_school_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/school_contact_logs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_school_contact_log_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"school_contact_logs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /school_contact_tbs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_school_contact_tb_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_contact_tbs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_files/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_school_file_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_files"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_notes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_school_note_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_resources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_school_resource_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/school_types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_school_type_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"school_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /searches/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"searches"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/senior_images/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_senior_image_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"senior_images"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /springappointments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_springappointment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"springappointments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/students/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_student_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student_images/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_student_image_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /successful_access_code_attempts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_successful_access_code_attempt_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"successful_access_code_attempts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /new_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"new_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/fields/new(.:format)
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_template_field_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/template_pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_template_page_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"template_pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/pdfs/new(.:format)
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_template_pdf_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"pdfs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/pdfs/:pdf_id/types/new(.:format)
 * @param {any} template_id
 * @param {any} pdf_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_template_pdf_type_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"pdf_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"pdfs"],[2,[7,"/"],[2,[3,"pdf_id"],[2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /new_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"new_templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /types/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/unprocessed_poses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_unprocessed_pose_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"unprocessed_poses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /unsubscribe_lists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_unsubscribe_list_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /uploads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_upload_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webcams/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_webcam_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webcams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbooks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_yearbook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbooks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_yearbook_admin_job_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/yearbook_contract_details/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_yearbook_contract_detail_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"yearbook_contract_details"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_email_lists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_yearbook_email_list_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_email_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/yearbook_previews/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_yearbook_preview_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"yearbook_previews"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_requests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_yearbook_request_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_submissions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_yearbook_submission_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_submissions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webcams/newstudent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newstudent_webcams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webcams"],[2,[7,"/"],[2,[6,"newstudent"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_notes/:id/:note(.:format)
 * @param {any} id
 * @param {any} note
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"note":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"school_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notes_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/notice_setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notice_setup_admin_generated_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[6,"notice_setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/awards/:id/notprocessed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notprocessed_admin_award_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"notprocessed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /school_notes/old_index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const old_index_school_notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_notes"],[2,[7,"/"],[2,[6,"old_index"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/options/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const option_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"options"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const options_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/cart/:cart_id/orders(.:format)
 * @param {any} cart_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_confirm_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/create_package(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_create_package_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"create_package"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/delete_package(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_delete_package_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"delete_package"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_download_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:id/export(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_export_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:id/find(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_find_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/:student_id/notprocessed(.:format)
 * @param {any} order_id
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_notprocessed_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"notprocessed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_packages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/orders/order_package_counts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_package_counts_orders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"order_package_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/orders/order_package_counts_other_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_package_counts_other_items_orders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"order_package_counts_other_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/orders/order_package_counts_seniors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_package_counts_seniors_orders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"order_package_counts_seniors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/order_package_extras/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_package_extra_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"order_package_extras"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/order_package_extras(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_package_extras_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"order_package_extras"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /order_packages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_packages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"order_packages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /order_packages/abandoned(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_packages_abandoned_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[6,"abandoned"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /order_packages/choose_yearbook_sales_or_submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_packages_choose_yearbook_sales_or_submit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[6,"choose_yearbook_sales_or_submit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /order_packages/csv_from_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_packages_csv_from_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[6,"csv_from_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /order_packages/formatted_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_packages_formatted_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[6,"formatted_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /order_packages/invoice/generate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_packages_invoice_generate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[6,"invoice"],[2,[7,"/"],[2,[6,"generate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:order_id/:student_id/processed(.:format)
 * @param {any} order_id
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_processed_path = /*#__PURE__*/ __jsr.r({"order_id":{"r":true},"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"order_id"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"processed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_show_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/:id/text_download_link(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const order_text_download_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"text_download_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /orders/add_image/:id/:index(.:format)
 * @param {any} id
 * @param {any} index
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_add_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"index":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"add_image"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/byorderid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_byorderid_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"byorderid"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/csharp_mark_shipped(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_csharp_mark_shipped_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"csharp_mark_shipped"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/csv_download_for_csharp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_csv_download_for_csharp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"csv_download_for_csharp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/csv_download_for_img_correction(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_csv_download_for_img_correction_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"csv_download_for_img_correction"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/csv_for_csharp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_csv_for_csharp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"csv_for_csharp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/customer_order_preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_customer_order_preview_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"customer_order_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/digital_download_ruby(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_digital_download_ruby_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"digital_download_ruby"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/edit_op_appointment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_edit_op_appointment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"edit_op_appointment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/edit_op_student(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_edit_op_student_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"edit_op_student"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/favorites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_favorites_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"favorites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/find_image(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_find_image_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"find_image"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/img_needs_correction(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_img_needs_correction_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"img_needs_correction"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_import_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/orders/print_order_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_orders_print_order_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"print_order_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/print_address(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_print_address_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"print_address"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/print_order_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_print_order_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"print_order_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/remove_image/:id/:index(.:format)
 * @param {any} id
 * @param {any} index
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_remove_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"index":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"remove_image"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/senior_digital_image_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_senior_digital_image_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"senior_digital_image_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/show_all/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_show_all_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"show_all"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /school_files/outgoing_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const outgoing_files_school_files_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_files"],[2,[7,"/"],[2,[6,"outgoing_files"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/packages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/package_poses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const package_pose_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"package_poses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/package_poses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const package_poses_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"package_poses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/packages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packages_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"packages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/packages(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packages_admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"packages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/orders/packages_for_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packages_for_export_orders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"packages_for_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/packages_list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packages_list_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"packages_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/:id/packaging_slip(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packaging_slip_djob_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"packaging_slip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/packing_slip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packing_slip_admin_generated_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[6,"packing_slip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/work_orders/:id/packing_slip(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const packing_slip_admin_work_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"packing_slip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/page_options/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_option_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"page_options"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/page_option_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_option_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"page_option_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/page_option_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_option_types_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"page_option_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/page_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_options_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"page_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/page_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"page_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/page_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_types_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"page_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation/parse_csv_headers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parse_csv_headers_admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[2,[7,"/"],[2,[6,"parse_csv_headers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation/parse_laptop_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parse_laptop_csv_admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[2,[7,"/"],[2,[6,"parse_laptop_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation/parse_sqlite(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parse_sqlite_admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[2,[7,"/"],[2,[6,"parse_sqlite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/past_images/:cart_id/:i(.:format)
 * @param {any} cart_id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const past_images_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"past_images"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payment_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"payment_notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /templates/pdf_diagnostic(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pdf_diagnostic_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"pdf_diagnostic"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /templates/:id/pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pdf_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /photographed_students/photographed_import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const photographed_students_photographed_import_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"photographed_students"],[2,[7,"/"],[2,[6,"photographed_import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /photographers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const photographer_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"photographers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /photographers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const photographers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"photographers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/calendar_jobs/photographers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const photographers_calendar_jobs_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"calendar_jobs"],[2,[7,"/"],[2,[6,"photographers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/pipeline_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pipeline_dashboard_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"pipeline_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/pipeline/process_complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pipeline_process_complete_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"pipeline"],[2,[7,"/"],[2,[6,"process_complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/pipeline/report_skipped(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pipeline_report_skipped_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"pipeline"],[2,[7,"/"],[2,[6,"report_skipped"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/pipeline/report_unextracted(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pipeline_report_unextracted_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"pipeline"],[2,[7,"/"],[2,[6,"report_unextracted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/pipeline/s3_file_notification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pipeline_s3_file_notification_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"pipeline"],[2,[7,"/"],[2,[6,"s3_file_notification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_drafts/templates/placeholders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const placeholders_admin_email_drafts_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_drafts"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"placeholders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation/plan_orphan_recovery(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plan_orphan_recovery_admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[2,[7,"/"],[2,[6,"plan_orphan_recovery"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/popularity_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const popularity_report_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"popularity_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /porders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const porder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"porders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /porders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const porders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"porders"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /students/:cart_id/senior_portrait_addons/:i(.:format)
 * @param {any} cart_id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portrait_addons_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"senior_portrait_addons"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/portrait_image_preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portrait_image_preview_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"portrait_image_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /students/:cart_id/senior_portraits/:i(.:format)
 * @param {any} cart_id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const portraits_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"senior_portraits"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/poses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pose_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"poses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pose_downloads/:id/status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pose_download_status_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pose_downloads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pose_downloads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pose_downloads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pose_downloads"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v2/poses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poses_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"poses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/poses_for_season(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const poses_for_season_admin_student_images_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[6,"poses_for_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation/presign_upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presign_upload_admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[2,[7,"/"],[2,[6,"presign_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/presigned_url(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presigned_url_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"presigned_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/presigned_urls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presigned_urls_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"presigned_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_drafts/templates/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_admin_email_drafts_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_drafts"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/job_reassignment/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_admin_job_reassignment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"job_reassignment"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/yearbook_campaigns/preview_contacts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_contacts_admin_yearbook_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"yearbook_campaigns"],[2,[7,"/"],[2,[6,"preview_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/dprojects/previous_contact_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previous_contact_email_dprojects_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"previous_contact_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/:id/previous_images/:i(.:format)
 * @param {any} id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previous_images_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"previous_images"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/dprojects/previous_requested_by(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previous_requested_by_dprojects_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"previous_requested_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_requests/previous_year_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const previous_year_data_yearbook_requests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_requests"],[2,[7,"/"],[2,[6,"previous_year_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/prices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const price_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"prices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/prices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prices_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"prices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/principal_corrections(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const principal_corrections_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"principal_corrections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:dproject_id/invoices/:id/print(.:format)
 * @param {any} dproject_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const print_dproject_invoice_path = /*#__PURE__*/ __jsr.r({"dproject_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"dproject_id"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"print"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/print_teachers(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const print_teachers_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"print_teachers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/print_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const print_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"print_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/print_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const print_templates_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"print_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /privacy-policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_policy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy-policy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /autos/:id/process_auto(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const process_auto_auto_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"process_auto"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/process_scan(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const process_scan_admin_generated_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[6,"process_scan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/awards/:id/processed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processed_admin_award_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"processed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /porders/processed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processed_porders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"porders"],[2,[7,"/"],[2,[6,"processed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/processing_events/batch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processing_events_batch_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"processing_events"],[2,[7,"/"],[2,[6,"batch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/processing_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processing_stats_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"processing_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/:id/product_packing_slip(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_packing_slip_admin_generated_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"product_packing_slip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/production_tracking_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const production_tracking_csv_djobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"production_tracking_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/promotional_sales_pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const promotional_sales_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"promotional_sales_pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/promotional_sales_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const promotional_sales_pages_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"promotional_sales_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /proxy_image(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const proxy_image_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"proxy_image"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/publish_all_seasons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_all_seasons_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"publish_all_seasons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/publish_season(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_season_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"publish_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/publish_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_status_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"publish_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /purchase_from_download/cart/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_from_download_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchase_from_download"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/purge_queue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purge_queue_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"purge_queue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/push_config(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const push_config_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"push_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /qr_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const qr_code_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"qr_code"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /templates/qr_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const qr_code_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"qr_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/queue_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const queue_status_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"queue_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sales_notes/quick_log(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quick_log_sales_note_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sales_notes"],[2,[7,"/"],[2,[6,"quick_log"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/:id/quick_ship(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quick_ship_dproject_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"quick_ship"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /generated_products/:id/quick_ship(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quick_ship_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"quick_ship"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sales_notes/quick_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quick_update_sales_note_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sales_notes"],[2,[7,"/"],[2,[6,"quick_update"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/:id/reassign_poses(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reassign_poses_admin_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reassign_poses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation/reconcile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reconcile_admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[2,[7,"/"],[2,[6,"reconcile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/recover_stuck(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recover_stuck_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"recover_stuck"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/reference_poses_for_season(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reference_poses_for_season_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"reference_poses_for_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /webcams/capture/webcams/refresh(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webcams"],[2,[7,"/"],[2,[6,"capture"],[2,[7,"/"],[2,[6,"webcams"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/refresh(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/carts/:id/refresh_volume_discount(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refresh_volume_discount_cart_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refresh_volume_discount"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/:id/regenerate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerate_admin_generated_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"regenerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_award_logs/regenerate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerate_admin_scheduled_award_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_award_logs"],[2,[7,"/"],[2,[6,"regenerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_sitting_card_logs/regenerate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerate_admin_scheduled_sitting_card_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_sitting_card_logs"],[2,[7,"/"],[2,[6,"regenerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/:id/regenerate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerate_admin_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"regenerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/:id/regenerate_spring(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerate_spring_admin_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"regenerate_spring"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/remove_addon/:order_package/:addon(.:format)
 * @param {any} order_package
 * @param {any} addon
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_addon_path = /*#__PURE__*/ __jsr.r({"order_package":{"r":true},"addon":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"remove_addon"],[2,[7,"/"],[2,[3,"order_package"],[2,[7,"/"],[2,[3,"addon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/packages/:id/remove_all_schools(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_all_schools_admin_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_all_schools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /remove_item/:citem(.:format)
 * @param {any} citem
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_item_path = /*#__PURE__*/ __jsr.r({"citem":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"remove_item"],[2,[7,"/"],[2,[3,"citem"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /students/remove_option/:order_package_id/:option_id/:i(.:format)
 * @param {any} order_package_id
 * @param {any} option_id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_option_path = /*#__PURE__*/ __jsr.r({"order_package_id":{"r":true},"option_id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"remove_option"],[2,[7,"/"],[2,[3,"order_package_id"],[2,[7,"/"],[2,[3,"option_id"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/:id/remove_package/:i/:did(.:format)
 * @param {any} id
 * @param {any} i
 * @param {any} did
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"i":{"r":true},"did":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_package"],[2,[7,"/"],[2,[3,"i"],[2,[7,"/"],[2,[3,"did"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/remove_teacher(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_teacher_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_teacher"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/job_reassignment/rename_execute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rename_execute_admin_job_reassignment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"job_reassignment"],[2,[7,"/"],[2,[6,"rename_execute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/job_reassignment/rename_preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rename_preview_admin_job_reassignment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"job_reassignment"],[2,[7,"/"],[2,[6,"rename_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/renewal_statuses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renewal_status_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"renewal_statuses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/renewal_statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renewal_statuses_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"renewal_statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/addons/reorder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorder_admin_addons_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/html_elements/reorder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorder_admin_api_html_elements_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"html_elements"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/school_resources/reorder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reorder_admin_school_resources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[6,"reorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/components/:id/html_elements/reparent(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reparent_admin_api_html_elements_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"html_elements"],[2,[7,"/"],[2,[6,"reparent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sms_conversations/:id/reply(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reply_admin_sms_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sms_conversations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/orders/reprint_item(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reprint_item_orders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"reprint_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/resend_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_password_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"resend_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/restart_instances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restart_instances_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"restart_instances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/:id/results(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const results_admin_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_jobs/results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const results_admin_scheduled_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_jobs"],[2,[7,"/"],[2,[6,"results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /face_matching/results(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const results_face_matching_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"face_matching"],[2,[7,"/"],[2,[6,"results"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation/resync_unattached_student_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resync_unattached_student_images_admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[2,[7,"/"],[2,[6,"resync_unattached_student_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /retake_request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retake_request_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"retake_request"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /customer_registrations/retake_request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retake_request_customer_registrations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customer_registrations"],[2,[7,"/"],[2,[6,"retake_request"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/retry_failed_yb_pages(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_failed_yb_pages_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry_failed_yb_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /carts/:id/return(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const return_cart_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"return"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /admin/rake_tasks/:id/run(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const run_admin_rake_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rake_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sales_calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sales_calls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sales_calls"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sales_calls/notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sales_calls_notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sales_calls"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sales_charts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sales_chart_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sales_charts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sales_charts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sales_charts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sales_charts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/awards/:id/save_award_info(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_award_info_admin_award_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_award_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /webcams/save_image(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_image_webcams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webcams"],[2,[7,"/"],[2,[6,"save_image"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /items/cart/:cart_id/save_school_info(.:format)
 * @param {any} cart_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_school_info_json_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"save_school_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /items/cart/:cart_id/item/:item_id/draft(.:format)
 * @param {any} cart_id
 * @param {any} item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_template_draft_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"item"],[2,[7,"/"],[2,[3,"item_id"],[2,[7,"/"],[2,[6,"draft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/scale_instances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scale_instances_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"scale_instances"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/scan_delivery(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scan_delivery_admin_generated_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[6,"scan_delivery"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scheduling(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduling_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"scheduling"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /schools/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/image_reconciliation/school_codes_for_season(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_codes_for_season_admin_image_reconciliation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"image_reconciliation"],[2,[7,"/"],[2,[6,"school_codes_for_season"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/school_contact_logs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_contact_log_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"school_contact_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/school_contact_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_contact_logs_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"school_contact_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /school_contact_tbs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_contact_tb_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"school_contact_tbs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_contact_tbs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_contact_tbs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_contact_tbs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /school_files/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"school_files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_files_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_files"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /items/cart/:cart_id/school_info(.:format)
 * @param {any} cart_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_info_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"school_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /school_notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"school_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_notes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/school_packages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_packages_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"school_packages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /school_resources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_resource_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_resources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_resources"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /school_resources/custom_school_select(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_resources_custom_school_select_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[6,"custom_school_select"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_resources/fall_request_confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_resources_fall_request_confirm_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[6,"fall_request_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_resources/fall_request_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_resources_fall_request_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[6,"fall_request_form"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_resources/fall_request_form2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_resources_fall_request_form2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[6,"fall_request_form2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_resources/holiday_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_resources_holiday_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[6,"holiday_form"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_resources/request_form_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_resources_request_form_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[6,"request_form_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_resources/santa_confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_resources_santa_confirm_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[6,"santa_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_resources/santa_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_resources_santa_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_resources"],[2,[7,"/"],[2,[6,"santa_form"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_notes/school(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_school_notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_notes"],[2,[7,"/"],[2,[6,"school"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /schools/:school_id/student/:id(.:format)
 * @param {any} school_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_student_path = /*#__PURE__*/ __jsr.r({"school_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"school_id"],[2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:school_id/student/:student_id/id_cards(.:format)
 * @param {any} school_id
 * @param {any} student_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_student_id_cards_path = /*#__PURE__*/ __jsr.r({"school_id":{"r":true},"student_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"school_id"],[2,[7,"/"],[2,[6,"student"],[2,[7,"/"],[2,[3,"student_id"],[2,[7,"/"],[2,[6,"id_cards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/school_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"school_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/school_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_types_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"school_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbooks/:id/school_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const school_user_yearbook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yearbooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"school_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"schools"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/orders/schools_for_export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schools_for_export_orders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"schools_for_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/schooledit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schools_schooledit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"schooledit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /schools/schoolupdate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schools_schoolupdate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"schoolupdate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbooks/schools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schools_yearbooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbooks"],[2,[7,"/"],[2,[6,"schools"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /searches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"searches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/items/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_admin_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/search_for_student(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_for_student_students_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"search_for_student"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /school_notes/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_school_notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_notes"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/search_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_students_admin_student_images_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[6,"search_students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/items/:id/search_term(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_term_admin_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"search_term"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /items/:id/search_term(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_term_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"search_term"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searches_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"searches"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /searches/orders/print_order_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searches_orders_print_order_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"searches"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"print_order_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/seasons(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seasons_admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"seasons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /select_appointment_package/:cart_id/:i(.:format)
 * @param {any} cart_id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_appointment_package_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"select_appointment_package"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/select_method(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_method_admin_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"select_method"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/select_school(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_school_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"select_school"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webcams/select(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_webcams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webcams"],[2,[7,"/"],[2,[6,"select"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/selective_process(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selective_process_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"selective_process"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/selective_process_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selective_process_status_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"selective_process_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/scheduled_jobs/:id/send_test(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_test_admin_scheduled_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/senior_blocks/send_test(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_test_admin_senior_blocks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"senior_blocks"],[2,[7,"/"],[2,[6,"send_test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/senior_images/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const senior_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"senior_images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/senior_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const senior_images_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"senior_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/qr_codes/seniorproof(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seniorproof_admin_qr_codes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"qr_codes"],[2,[7,"/"],[2,[6,"seniorproof"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /seniors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seniors_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"seniors"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/service_health(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const service_health_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"service_health"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/service_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const service_status_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"service_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/set_best_pose(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_best_pose_admin_student_images_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[6,"set_best_pose"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/carts/set_cart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_cart_carts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"carts"],[2,[7,"/"],[2,[6,"set_cart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/set_process_all_flag(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_process_all_flag_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"set_process_all_flag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/:id/setprimaryimage(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setprimaryimage_admin_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"setprimaryimage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sheets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sheet_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sheets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sheets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sheets_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sheets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/templating/sheets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sheets_admin_templating_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"templating"],[2,[7,"/"],[2,[6,"sheets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/shipment_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shipment_history_dprojects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"shipment_history"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /shoob_appointment/:cart_id/:i(.:format)
 * @param {any} cart_id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shoob_appointment_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shoob_appointment"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/shooting_schedules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shooting_schedule_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"shooting_schedules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/shooting_schedules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shooting_schedules_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"shooting_schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shop_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /shop/customers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shop_customer_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/pictures/find-my-student(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shop_pictures_find_my_student_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"pictures"],[2,[7,"/"],[2,[6,"find-my-student"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shop/pictures/find_my_student_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shop_pictures_find_my_student_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"shop"],[2,[7,"/"],[2,[6,"pictures"],[2,[7,"/"],[2,[6,"find_my_student_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/show_gift/:cart_id/:i/:gift_id(.:format)
 * @param {any} cart_id
 * @param {any} i
 * @param {any} gift_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_gift_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"i":{"r":true},"gift_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"show_gift"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[3,"i"],[2,[7,"/"],[2,[3,"gift_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sibling_images/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sibling_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sibling_images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sibling_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sibling_images_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sibling_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiq_web_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"sidekiq"]]);

/**
 * Generates rails route to
 * /api/v1/orders/similar_address(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const similar_address_orders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"similar_address"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /student_images/skylab_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skylab_callback_student_images_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[6,"skylab_callback"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/students/:id/soft_delete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const soft_delete_admin_student_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"soft_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dprojects/sort(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sort_dprojects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"sort"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /djobs/:id/specs(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const specs_djob_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"specs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /school_files/splash(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const splash_school_files_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"school_files"],[2,[7,"/"],[2,[6,"splash"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /springappointments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const springappointment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"springappointments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /springappointments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const springappointments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"springappointments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /springappointments/job_confirmations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const springappointments_job_confirmations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"springappointments"],[2,[7,"/"],[2,[6,"job_confirmations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /springappointments/send_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const springappointments_send_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"springappointments"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /springappointments/send_email_schools(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const springappointments_send_email_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"springappointments"],[2,[7,"/"],[2,[6,"send_email_schools"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /face_matching/start_analysis(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_analysis_face_matching_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"face_matching"],[2,[7,"/"],[2,[6,"start_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /autos/start_auto(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_auto_autos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"autos"],[2,[7,"/"],[2,[6,"start_auto"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/districts/:id/start_delete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_delete_admin_district_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"districts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"start_delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /autos/start_import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_import_autos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"autos"],[2,[7,"/"],[2,[6,"start_import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/orders/states(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const states_orders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"states"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/job_reassignment/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_admin_job_reassignment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"job_reassignment"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rake_tasks/:id/status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_admin_rake_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rake_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/students/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/addons/:cart/:i/:option/:op(.:format)
 * @param {any} cart
 * @param {any} i
 * @param {any} option
 * @param {any} op
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_addons_path = /*#__PURE__*/ __jsr.r({"cart":{"r":true},"i":{"r":true},"option":{"r":true},"op":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"addons"],[2,[7,"/"],[2,[3,"cart"],[2,[7,"/"],[2,[3,"i"],[2,[7,"/"],[2,[3,"option"],[2,[7,"/"],[2,[3,"op"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/:id/calculate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_calculate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"calculate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/cart/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_cart_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /download/images/:shoob_id/:cart_id(.:format)
 * @param {any} shoob_id
 * @param {any} cart_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_download_path = /*#__PURE__*/ __jsr.r({"shoob_id":{"r":true},"cart_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"shoob_id"],[2,[7,"/"],[2,[3,"cart_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/duplicate/:school(.:format)
 * @param {any} school
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_duplicate_path = /*#__PURE__*/ __jsr.r({"school":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"duplicate"],[2,[7,"/"],[2,[3,"school"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/packages/:cart_id/final/:i(.:format)
 * @param {any} cart_id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_final_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"final"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_find_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_find_student_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /students/findbyid/:school(.:format)
 * @param {any} school
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_findbyid_path = /*#__PURE__*/ __jsr.r({"school":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"findbyid"],[2,[7,"/"],[2,[3,"school"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /student_images/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /student_images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_images_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student_images"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /appointments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"appointments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /students/input/:school/:cart/:i(.:format)
 * @param {any} school
 * @param {any} cart
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_input_path = /*#__PURE__*/ __jsr.r({"school":{"r":true},"cart":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"input"],[2,[7,"/"],[2,[3,"school"],[2,[7,"/"],[2,[3,"cart"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/packages/:id/:i(.:format)
 * @param {any} id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_packages_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/packages/:id/:i/:package_id/pick_favorites(.:format)
 * @param {any} id
 * @param {any} i
 * @param {any} package_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_pick_favorites_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"i":{"r":true},"package_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"i"],[2,[7,"/"],[2,[3,"package_id"],[2,[7,"/"],[2,[6,"pick_favorites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/preview_image(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_preview_image_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"preview_image"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /promotional_images/student_promo_image(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_promo_image_promotional_images_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"promotional_images"],[2,[7,"/"],[2,[6,"student_promo_image"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /download/download_image/:student(.:format)
 * @param {any} student
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_push_image_path = /*#__PURE__*/ __jsr.r({"student":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"download_image"],[2,[7,"/"],[2,[3,"student"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /download/download_png_image/:student(.:format)
 * @param {any} student
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_push_png_image_path = /*#__PURE__*/ __jsr.r({"student":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"download_png_image"],[2,[7,"/"],[2,[3,"student"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/packages/:id/review/:i(.:format)
 * @param {any} id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_review_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/school_find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_school_find_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"school_find"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /students/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /students/cart/:cart_id/select/:i(.:format)
 * @param {any} cart_id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_select_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"select"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/:cart_id/select_appointment/:i/:package_id(.:format)
 * @param {any} cart_id
 * @param {any} i
 * @param {any} package_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_select_appointment_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"i":{"r":true},"package_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"select_appointment"],[2,[7,"/"],[2,[3,"i"],[2,[7,"/"],[2,[3,"package_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/packages/:id/:i/:package_id/select_favorites(.:format)
 * @param {any} id
 * @param {any} i
 * @param {any} package_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_select_favorites_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"i":{"r":true},"package_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"i"],[2,[7,"/"],[2,[3,"package_id"],[2,[7,"/"],[2,[6,"select_favorites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/packages/:id/select/:i/:package(.:format)
 * @param {any} id
 * @param {any} i
 * @param {any} package
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_select_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"i":{"r":true},"package":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select"],[2,[7,"/"],[2,[3,"i"],[2,[7,"/"],[2,[3,"package"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/showteacher/:school(.:format)
 * @param {any} school
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_showteacher_path = /*#__PURE__*/ __jsr.r({"school":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"showteacher"],[2,[7,"/"],[2,[3,"school"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/special_offer/:cart/:i/:option/:op(.:format)
 * @param {any} cart
 * @param {any} i
 * @param {any} option
 * @param {any} op
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_special_offer_path = /*#__PURE__*/ __jsr.r({"cart":{"r":true},"i":{"r":true},"option":{"r":true},"op":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"special_offer"],[2,[7,"/"],[2,[3,"cart"],[2,[7,"/"],[2,[3,"i"],[2,[7,"/"],[2,[3,"option"],[2,[7,"/"],[2,[3,"op"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/access_or_id(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_splash_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"access_or_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /students/:id/update/:i(.:format)
 * @param {any} id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_update_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/yearbook/:opackage(.:format)
 * @param {any} opackage
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_yearbook_path = /*#__PURE__*/ __jsr.r({"opackage":{"r":true},"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"yearbook"],[2,[7,"/"],[2,[3,"opackage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const students_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/apply_coupon(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const students_apply_coupon_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"apply_coupon"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /students/lessonbuilder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const students_lessonbuilder_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"lessonbuilder"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/students_missing_id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const students_missing_id_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"students_missing_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/students_missing_teacher(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const students_missing_teacher_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"students_missing_teacher"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/students/students_per_teacher(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const students_per_teacher_students_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"students_per_teacher"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/submit_campaign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_campaign_admin_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"submit_campaign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/submit_composite(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_composite_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_composite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/submit_staff_composite(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_staff_composite_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_staff_composite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /contracts/:id/success(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /successful_access_code_attempts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const successful_access_code_attempt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"successful_access_code_attempts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /successful_access_code_attempts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const successful_access_code_attempts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"successful_access_code_attempts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/:id/swap(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const swap_admin_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"swap"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/sync(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/sync_all_stuck_paperclip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_all_stuck_paperclip_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"sync_all_stuck_paperclip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/sync_paperclip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_paperclip_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"sync_paperclip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/sync_paperclip_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_paperclip_status_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"sync_paperclip_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/sync_s3(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_s3_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"sync_s3"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/sync_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sync_status_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"sync_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/students/teacher_aids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teacher_aids_students_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"teacher_aids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/teacher_corrections(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teacher_corrections_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"teacher_corrections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_imports/:id/teachers(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teachers_admin_student_import_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"teachers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /export_list_items/teachers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teachers_export_list_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export_list_items"],[2,[7,"/"],[2,[6,"teachers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/students/teachers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teachers_students_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"teachers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/fields/:id(.:format)
 * @param {any} template_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const template_field_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/fields(.:format)
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const template_fields_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /template_pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const template_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"template_pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /template_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const template_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"template_pages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/pdfs/:id(.:format)
 * @param {any} template_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const template_pdf_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"pdfs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/pdfs/:pdf_id/types/:id(.:format)
 * @param {any} template_id
 * @param {any} pdf_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const template_pdf_type_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"pdf_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"pdfs"],[2,[7,"/"],[2,[3,"pdf_id"],[2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/pdfs/:pdf_id/types(.:format)
 * @param {any} template_id
 * @param {any} pdf_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const template_pdf_types_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"pdf_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"pdfs"],[2,[7,"/"],[2,[3,"pdf_id"],[2,[7,"/"],[2,[6,"types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/pdfs(.:format)
 * @param {any} template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const template_pdfs_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"pdfs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /template_products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const template_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"template_products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const templates_admin_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/yearbook_campaigns/templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const templates_admin_yearbook_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"yearbook_campaigns"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbooks/templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const templates_yearbooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbooks"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/test-payment-intent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_payment_intent_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"test-payment-intent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /test_route(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_route_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"test_route"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /contracts/:id/test_user_view(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_user_view_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test_user_view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/dprojects/todays_shipments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const todays_shipments_dprojects_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"dprojects"],[2,[7,"/"],[2,[6,"todays_shipments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/template_maintenance/toggle_category(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_category_admin_template_maintenance_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"template_maintenance"],[2,[7,"/"],[2,[6,"toggle_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/senior_blocks/toggle_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_status_admin_senior_blocks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"senior_blocks"],[2,[7,"/"],[2,[6,"toggle_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/:id/transfer(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transfer_admin_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transfer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/packages/:id/transfer_schools(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transfer_schools_admin_package_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transfer_schools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/student_images/:id/transferpose(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transferpose_admin_student_image_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"student_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"transferpose"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/generated_products/trigger(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trigger_admin_generated_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[6,"trigger"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /twilio/incoming_sms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twilio_incoming_sms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"twilio"],[2,[7,"/"],[2,[6,"incoming_sms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /twilio/status_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twilio_status_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"twilio"],[2,[7,"/"],[2,[6,"status_callback"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /students/typeahead(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const typeahead_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"typeahead"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webcams/types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const types_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"webcams"],[2,[7,"/"],[2,[6,"types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/unbilled_projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unbilled_projects_admin_invoices_path = /*#__PURE__*/ __jsr.r({"format":{"d":"csv"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"unbilled_projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /export_list_items/unphotographed_students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unphotographed_students_export_list_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"export_list_items"],[2,[7,"/"],[2,[6,"unphotographed_students"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /porders/unprocessed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unprocessed_porders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"porders"],[2,[7,"/"],[2,[6,"unprocessed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/unprocessed_poses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unprocessed_pose_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"unprocessed_poses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v3/unprocessed_poses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unprocessed_poses_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"unprocessed_poses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v4/unprocessed_poses/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unprocessed_poses_confirm_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v4"],[2,[7,"/"],[2,[6,"unprocessed_poses"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v4/unprocessed_poses/intake_complete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unprocessed_poses_intake_complete_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v4"],[2,[7,"/"],[2,[6,"unprocessed_poses"],[2,[7,"/"],[2,[6,"intake_complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v4/unprocessed_poses/presign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unprocessed_poses_presign_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v4"],[2,[7,"/"],[2,[6,"unprocessed_poses"],[2,[7,"/"],[2,[6,"presign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sms_conversations/unread_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unread_count_admin_sms_conversations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sms_conversations"],[2,[7,"/"],[2,[6,"unread_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /unsubscribe_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /unsubscribe_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe_lists"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/update_admin_notes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_admin_notes_admin_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_admin_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/update_award_info(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_award_info_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_award_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/cart/:cart_id/update_cart/:i(.:format)
 * @param {any} cart_id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_cart_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"update_cart"],[2,[7,"/"],[2,[3,"i"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /order_packages/update_cart_email/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_cart_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[6,"update_cart_email"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /update_cart_item/:citem(.:format)
 * @param {any} citem
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_cart_item_path = /*#__PURE__*/ __jsr.r({"citem":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"update_cart_item"],[2,[7,"/"],[2,[3,"citem"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/students/:id/update_classroom_teacher(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_classroom_teacher_student_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_classroom_teacher"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/update_composite_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_composite_status_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_composite_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/cart/:id/:i/update_download(.:format)
 * @param {any} id
 * @param {any} i
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_download_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"i":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"i"],[2,[7,"/"],[2,[6,"update_download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs/:id/update_field(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_field_yearbook_admin_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_field"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /items/cart/:cart_id/update_items(.:format)
 * @param {any} cart_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_items_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"update_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/update_multiple_award_info(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_multiple_award_info_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_multiple_award_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /awards/:id/update_multiple_award_info_csv(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_multiple_award_info_csv_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"awards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_multiple_award_info_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /djobs/update_multiple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_multiple_djobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"djobs"],[2,[7,"/"],[2,[6,"update_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /order_packages/update_multiple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_multiple_order_packages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"order_packages"],[2,[7,"/"],[2,[6,"update_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/calendar_jobs/:id/update_notes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_notes_calendar_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"calendar_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/fields/:id/update_overlay_image(.:format)
 * @param {any} template_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_overlay_image_template_field_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_overlay_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/update_password(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_password_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:id/update_pdf(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_pdf_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_pdf"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/fields/:id/update_personalization_box(.:format)
 * @param {any} template_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_personalization_box_template_field_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_personalization_box"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /students/:cart_id/update_portraits/:image_type/:index/:opackage(.:format)
 * @param {any} cart_id
 * @param {any} image_type
 * @param {any} index
 * @param {any} opackage
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_portraits_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"image_type":{"r":true},"index":{"r":true},"opackage":{"r":true},"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"update_portraits"],[2,[7,"/"],[2,[3,"image_type"],[2,[7,"/"],[2,[3,"index"],[2,[7,"/"],[2,[3,"opackage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/update_proof_type(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_proof_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_proof_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/calendar_jobs/:id/update_rigs(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rigs_calendar_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"calendar_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_rigs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/update_schedule(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_schedule_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"update_schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /items/cart/:cart_id/update_school_info(.:format)
 * @param {any} cart_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_school_info_path = /*#__PURE__*/ __jsr.r({"cart_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"cart"],[2,[7,"/"],[2,[3,"cart_id"],[2,[7,"/"],[2,[6,"update_school_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /templates/:template_id/fields/:id/update_school_logo(.:format)
 * @param {any} template_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_school_logo_template_field_path = /*#__PURE__*/ __jsr.r({"template_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"template_id"],[2,[7,"/"],[2,[6,"fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_school_logo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/schools/:id/update_prospect_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_school_prospect_status_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_prospect_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/calendar_jobs/:id/update_status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_status_calendar_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"calendar_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /webcams/update_student(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_student_webcams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webcams"],[2,[7,"/"],[2,[6,"update_student"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/template_maintenance/update_template(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_template_admin_template_maintenance_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"template_maintenance"],[2,[7,"/"],[2,[6,"update_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /school_notes/:id/updatenote(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatenote_school_note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"school_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"updatenote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/upload_buy_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_buy_all_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"upload_buy_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /uploads/:token/conflict(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_conflict_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"conflict"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/favorites_designer/upload_overlay(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_overlay_admin_favorites_designer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"favorites_designer"],[2,[7,"/"],[2,[6,"upload_overlay"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /uploads/:token/resolve(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_resolve_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"uploads"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v2/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/generate_otp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_generate_otp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"generate_otp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/login_with_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_login_with_code_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"login_with_code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/orders/validate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_orders_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/verify_gifs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_gifs_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"verify_gifs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ec2_processor/verify_gifs_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_gifs_status_admin_ec2_processor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ec2_processor"],[2,[7,"/"],[2,[6,"verify_gifs_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/view_addons/:order_package(.:format)
 * @param {any} order_package
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const view_addons_path = /*#__PURE__*/ __jsr.r({"order_package":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"view_addons"],[2,[7,"/"],[2,[3,"order_package"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/view_all_teachers(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const view_all_teachers_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"view_all_teachers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /students/view_package/:order_package(.:format)
 * @param {any} order_package
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const view_package_path = /*#__PURE__*/ __jsr.r({"order_package":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"students"],[2,[7,"/"],[2,[6,"view_package"],[2,[7,"/"],[2,[3,"order_package"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /generated_products/:id/void_shipment(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const void_product_shipment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"generated_products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"void_shipment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /webcams/waiting/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const waiting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"webcams"],[2,[7,"/"],[2,[6,"waiting"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/waiting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const waiting_admin_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"waiting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/qr_codes/waiting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const waiting_admin_qr_codes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"qr_codes"],[2,[7,"/"],[2,[6,"waiting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/waiting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const waiting_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"waiting"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /templates/:id/waiting(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const waiting_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"waiting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /schools/waiting_zip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const waiting_zip_schools_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[6,"waiting_zip"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webcams/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webcam_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"webcams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webcams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webcams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webcams"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /unsubscribe_lists/webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_unsubscribe_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe_lists"],[2,[7,"/"],[2,[6,"webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/appointments/weekly(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weekly_admin_appointments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"appointments"],[2,[7,"/"],[2,[6,"weekly"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbooks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yearbooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_admin_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_admin_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs/cover_match_audit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_admin_jobs_cover_match_audit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[2,[7,"/"],[2,[6,"cover_match_audit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs/cover_reprint_search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_admin_jobs_cover_reprint_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[2,[7,"/"],[2,[6,"cover_reprint_search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs/cover_reprint_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_admin_jobs_cover_reprint_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[2,[7,"/"],[2,[6,"cover_reprint_status"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs/cover_reprint_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_admin_jobs_cover_reprint_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[2,[7,"/"],[2,[6,"cover_reprint_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs/cover_reprint_unshipped(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_admin_jobs_cover_reprint_unshipped_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[2,[7,"/"],[2,[6,"cover_reprint_unshipped"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs/cover_reprints(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_admin_jobs_cover_reprints_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[2,[7,"/"],[2,[6,"cover_reprints"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs/shipping_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_admin_jobs_shipping_report_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[2,[7,"/"],[2,[6,"shipping_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs/teacher_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_admin_jobs_teacher_report_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[2,[7,"/"],[2,[6,"teacher_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs/trigger_yearbook_covers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_admin_jobs_trigger_yearbook_covers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[2,[7,"/"],[2,[6,"trigger_yearbook_covers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/yearbook_contract_details/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_contract_detail_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"yearbook_contract_details"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/yearbook_contract_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_contract_details_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"yearbook_contract_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_email_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_email_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yearbook_email_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_email_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_email_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_email_lists"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /yearbook_email_lists/send_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_email_lists_send_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_email_lists"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbooks_orders/:id/export(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_order_export_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yearbooks_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/yearbook_previews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_preview_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"yearbook_previews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v2/yearbook_previews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_previews_path = /*#__PURE__*/ __jsr.r({"format":{"d":"jsonapi"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"yearbook_previews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_admin_jobs/production_tracking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_production_tracking_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_admin_jobs"],[2,[7,"/"],[2,[6,"production_tracking"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_request_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yearbook_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_requests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_requests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /yearbook_submissions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_submission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"yearbook_submissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_submissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_submissions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_submissions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /yearbook_submissions/after_submit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_submissions_after_submit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_submissions"],[2,[7,"/"],[2,[6,"after_submit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_submissions/download_cover(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_submissions_download_cover_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_submissions"],[2,[7,"/"],[2,[6,"download_cover"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_submissions/yearbook_info_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_submissions_yearbook_info_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_submissions"],[2,[7,"/"],[2,[6,"yearbook_info_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_submissions/yearbook_not_submitted_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_submissions_yearbook_not_submitted_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_submissions"],[2,[7,"/"],[2,[6,"yearbook_not_submitted_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbook_submissions/yearbook_orders_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_submissions_yearbook_orders_csv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbook_submissions"],[2,[7,"/"],[2,[6,"yearbook_orders_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /schools/:id/yearbook_teachers(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbook_teachers_school_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"schools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"yearbook_teachers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbookadminjobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbookadminjobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbookadminjobs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /yearbookadminjobs/assign_extra_cover(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbookadminjobs_assign_extra_cover_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbookadminjobs"],[2,[7,"/"],[2,[6,"assign_extra_cover"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbookadminjobs/email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbookadminjobs_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbookadminjobs"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbookadminjobs/extra_covers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbookadminjobs_extra_covers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbookadminjobs"],[2,[7,"/"],[2,[6,"extra_covers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbookadminjobs/generate_cover(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbookadminjobs_generate_cover_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbookadminjobs"],[2,[7,"/"],[2,[6,"generate_cover"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbookadminjobs/inboxoutbox(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbookadminjobs_inboxoutbox_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbookadminjobs"],[2,[7,"/"],[2,[6,"inboxoutbox"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbookadminjobs/makecsv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbookadminjobs_makecsv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbookadminjobs"],[2,[7,"/"],[2,[6,"makecsv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbookadminjobs/sales_report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbookadminjobs_sales_report_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbookadminjobs"],[2,[7,"/"],[2,[6,"sales_report"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbookadminjobs/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbookadminjobs_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbookadminjobs"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbookadminjobs/send_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbookadminjobs_send_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbookadminjobs"],[2,[7,"/"],[2,[6,"send_email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /yearbooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yearbooks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /orders/:id/yearbook_export(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbooks_export_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"yearbook_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /yearbooks_orders(/:school_id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yearbooks_orders_path = /*#__PURE__*/ __jsr.r({"school_id":{},"format":{}}, [2,[7,"/"],[2,[6,"yearbooks_orders"],[2,[1,[2,[7,"/"],[3,"school_id"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /yorders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yorders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yorders"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/s3_downloads/zip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zip_admin_s3_downloads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"s3_downloads"],[2,[7,"/"],[2,[6,"zip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /zip_code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zip_code_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"zip_code"],[1,[2,[8,"."],[3,"format"]]]]]);


